<template>
  <div class="ticket-page">
    <loadingcomp :mesaj="' '" v-model="loadingvmodel"></loadingcomp>
    <snackbarcomp :mesaj="text1" ref="showMessage" v-model="snackbar"></snackbarcomp>
    <hatadialog ref="hatadialog"></hatadialog>
    <v-dialog v-model="servisdialog" persistent max-width="650px">
  <v-card>
    <v-toolbar dark color="info">
      <v-toolbar-title>{{ $t('Service-Code-Selection') }}</v-toolbar-title>
      <v-spacer></v-spacer>
    </v-toolbar>

    <v-card-text>
      <v-data-table
        :headers="servisheaders"
        :items="servisitems"
        hide-actions
      >
        <template slot="items" slot-scope="props">
          <tr
            @click="servissec(props.item)"
            style="cursor:pointer"
          >
            <td>{{ props.item.Kod }}</td>
            <td>{{ props.item.Aciklama }}</td>
            <td>{{ props.item.Tutar }}</td>
            <td>{{ props.item.DovizKod }}</td>
          </tr>
        </template>
      </v-data-table>
    </v-card-text>

    <v-card-actions>
      <v-spacer></v-spacer>

      <v-btn
        flat
        color="primary"
        @click="servisdialog = false"
      >
        {{ $t('cancel_button') }}
      </v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>

<v-dialog ref="yenidialog" v-model="yeniKayitDialog" persistent max-width="400px">
  <v-card color="grey lighten-5">
    <v-flex xs12 sm12>
      <v-toolbar size="120px" dark color="info">
        <v-toolbar-title>{{ $t('New-Record') }}</v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>
    </v-flex>

    <v-card-text>
      <v-layout wrap>
        <div class="flex md12">
          <yenibiletno v-model="Bilet"></yenibiletno>
        </div>
      </v-layout>
    </v-card-text>

    <v-card-actions>
      <v-spacer></v-spacer>

      <v-btn color="blue darken-1" flat @click="sayfakapat()">
        {{ $t('cancel_button') }}
      </v-btn>

      <v-btn color="info" flat @click="popupDevamEt()">
         {{ $t('Continue') }}
      </v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>

    <v-form ref="formticket" v-model="valid" lazy-validation>
      <!-- HERO -->
<div class="hero-bar">
  <div class="hero-left">
    <div class="hero-badge">{{$t('Ticket-Sales')}}</div>
    <h1 class="hero-title">{{$t('Ticket-Sales')}}</h1>
  </div>

  <div class="hero-actions">
  <v-btn class="hero-btn" depressed @click="checkCounter()">
    <span v-if="guncellebtngorunum">{{ $t('Update') }}</span>
    <span v-else>{{$t('save_button')}}</span>
    <v-icon right>save</v-icon>
  </v-btn>

  <v-menu offset-y left>
    <v-btn slot="activator" class="hero-more-btn" depressed icon>
      <v-icon>more_vert</v-icon>
    </v-btn>

   <v-list>
  <v-list-tile v-if="voidbtn" :disabled="!sayfayetki.Update" @click="voidyap()">
    <v-list-tile-title>{{ $t('Make-it-Void') }}</v-list-tile-title>
  </v-list-tile>

  <v-list-tile v-if="guncellebtngorunum" :disabled="!sayfayetki.Delete" @click="biletsilsor()">
    <v-list-tile-title>{{ $t('Delete-Ticket') }}</v-list-tile-title>
  </v-list-tile>

  <v-list-tile v-if="!faturabtn && faturalansinmi==true" :disabled="!sayfayetki.Update" @click="faturadialogackontrol()">
    <v-list-tile-title>{{ $t('Bill') }}</v-list-tile-title>
  </v-list-tile>

  <v-list-tile v-if="faturanovarise" @click="faturaEBDuzenle()">
    <v-list-tile-title>{{ $t('Invoice-Issued-Ticket-Change') }}</v-list-tile-title>
  </v-list-tile>

  <v-list-tile v-if="iadebtn" :disabled="!sayfayetki.Update" @click="yeniiadeekle()">
    <v-list-tile-title>{{ $t('Add-v2', { value: $t('Refund')}) }}</v-list-tile-title>
  </v-list-tile>

  <v-list-tile v-if="guncellebtngorunum" :disabled="!sayfayetki.Update" @click="hykoddegistir()">
    <v-list-tile-title>{{ $t('Change-Airline-Code') }}</v-list-tile-title>
  </v-list-tile>

  <v-list-tile @click="openPdfDialog()">
    <v-list-tile-title>{{ $t('PDF-Download') }}</v-list-tile-title>
  </v-list-tile>

  <v-list-tile @click="showLogModal = true">
    <v-list-tile-title>{{ $t('Change-Logs') }}</v-list-tile-title>
  </v-list-tile>
</v-list>
  </v-menu>
</div>
</div>

<!-- HERO ALTI ÖZET -->
<div class="summary-card summary-card--top">
  <div class="summary-grid">
    <div class="summary-airline">
      <div class="airline-logo-wrap">
        <v-img
          :src="getImgUrl(Bilet.GenelBilgileri.HavaYoluKodu)"
          contain
          height="64"
          width="64"
        ></v-img>
      </div>

      <div class="airline-info">
        <div class="airline-line">
          <v-chip
            v-if="Bilet.GenelBilgileri.UcusTipi=='I'"
            small
            color="green"
            text-color="white"
          >
            {{ $t('Domestic-Line') }}
          </v-chip>

          <v-chip
            v-if="Bilet.GenelBilgileri.UcusTipi=='D'"
            small
            color="info"
            text-color="white"
          >
            {{ $t('International-Line') }}
          </v-chip>
          <v-chip
  v-if="Bilet.GenelBilgileri.UcusTipi=='B'"
  small
  color="orange"
  text-color="white"
>
  BSP
</v-chip>

          <span class="ticket-code">
            -{{Bilet.GenelBilgileri.Formno}}-{{Bilet.GenelBilgileri.BiletNo}}-{{Bilet.GenelBilgileri.HavaYoluKodu}}
          </span>
        </div>

        <v-chip
  v-if="iadeKaydiVarMi()"
  small
  color="red"
  text-color="white"
  class="refund-status-chip"
>
  {{ $t('Refund') }}
</v-chip>
<v-chip
  v-if="
    Bilet.GenelBilgileri.Acente === 'A' &&
    Bilet.GenelBilgileri.AcenteKodu
  "
  small
  text-color="white"
  class="agency-ticket-chip"
>
  <v-icon left small>store</v-icon>

  {{ $t('This-Ticket') }}
  <strong class="agency-ticket-code">
    {{ Bilet.GenelBilgileri.AcenteKodu }}
  </strong>
  {{ $t('received-from-the-agency') }}
</v-chip>

<div class="meta-line">
  {{$t('Invoice-Series-No')}}:
  {{Bilet.FaturaBilgileri.FaturaSeri}} {{Bilet.FaturaBilgileri.FaturaNo}}
</div>

        <div class="meta-line">
          {{$t('Invoice-Series-No')}}:
          {{Bilet.FaturaBilgileri.FaturaSeri}} {{Bilet.FaturaBilgileri.FaturaNo}}
        </div>

        <div class="meta-line">
          {{$t('Invoice-Date')}}:
          {{Bilet.FaturaBilgileri.FaturaTarihi | dateformat}}
        </div>

        <div class="invoice-switch-wrap">
  <v-switch
    v-model="faturalansinmi"
    hide-details
    inset
    class="modern-switch"
  ></v-switch>
  

  <span class="switch-label">
    {{ faturalansinmi ? $t('This-Ticket-Can-Be-Invoiced') : $t('This-Ticket-Will-Not-Be-Invoiced') }}
  </span>
</div>
      </div>
    </div>

    <div class="summary-total">
      <div class="summary-amount">
        {{Bilet.TutarBilgileri.NetTutar.NetTutar | moneyformat}}{{getparabirimi()}}
      </div>

      <div
        v-if="Bilet.TutarBilgileri.NetTutar.NetTutarSatisDoviz>0"
        class="summary-amount-sub"
      >
        {{Bilet.TutarBilgileri.NetTutar.NetTutarSatisDoviz}}
        {{Bilet.TutarBilgileri.Doviz.DovizKod}}
      </div>

      <div class="summary-label">{{$t('totalamount')}}</div>
    </div>
  </div>
</div>

<!-- GENEL -->
<section class="page-section">
  <div class="section-header">
    <h2>{{$t('General-Information')}}</h2>
  </div>

  <v-card class="general-wrapper-card" flat>
    <div class="general-inner">
      <v-layout row wrap>
        <v-flex xs12 md4 pa-2>
          <v-card class="content-card" flat>
            <div class="card-title">{{$t('Customer-Account-and-Passenger')}}</div>

            <v-card-text>
              <v-layout row wrap>
                <v-flex xs12>
                  <caricomp
                    ref="cariAnaComp"
                    :statecariyedek="caricompitems"
                    :zorunlumu="true"
                    @sendCurrentInfo="getCurrentInfov2($event)"
                    v-model="Bilet.GenelBilgileri.MusteriKodu.Kod"
                  ></caricomp>
                </v-flex>

                <v-flex xs12>
                  <v-text-field
                    class="modern-field"
                    :label="$t('Name-of-Passenger')"
                    v-model="Bilet.GenelBilgileri.YolcuAdi"
                    hide-details
                    outlined
                  ></v-text-field>
                </v-flex>

                <v-flex xs12 md6>
                  <v-autocomplete
                    class="modern-field"
                    :items="itemsKayitTipi"
                    hide-details
                    v-model="Bilet.GenelBilgileri.RecordTypeInfo.RecordTypeID"
                    item-text="Aciklama"
                    item-value="Kod"
                    :label="$t('Record-Type')"
                    outlined
                  ></v-autocomplete>
                </v-flex>

                <v-flex xs12 md6>
                  <tarihim
                    :etiket="$t('Sales-Date')"
                    :defaultvalue="'ok'"
                    :value="Bilet.TarihBilgileri.SatisTarihi"
                    v-model="Bilet.TarihBilgileri.SatisTarihi"
                  ></tarihim>
                </v-flex>

                <v-flex xs12 md6>
                  <tarihim
                    :etiket="$t('Date-of-Ticket-Issue')"
                    :defaultvalue="'ok'"
                    :value="Bilet.TarihBilgileri.KesimTarihi"
                    v-model="Bilet.TarihBilgileri.KesimTarihi"
                  ></tarihim>
                </v-flex>

                <v-flex xs12 md6>
                  <kesenkisi
                    :etiket="$t('Ticket-Agent')"
                    v-model="Bilet.GenelBilgileri.KesenKisi"
                  ></kesenkisi>
                </v-flex>

                <v-flex xs12 md6>
                  <v-text-field
                    class="modern-field"
                    label="PNR"
                    v-model="Bilet.GenelBilgileri.PnrNo"
                    hide-details
                    outlined
                  ></v-text-field>
                </v-flex>

                <v-flex xs12 md6>
                  <v-text-field
                    class="modern-field"
                    label="PIN Code"
                    v-model="Bilet.DigerBilgileri.PinKodu"
                    hide-details
                    outlined
                  ></v-text-field>
                </v-flex>

                <v-flex xs12 md6>
                  <v-select
                    class="modern-field"
                    :items="biletyon"
                    v-model="Bilet.GenelBilgileri.BiletYon"
                    clearable
                    item-text="text"
                    item-value="value"
                    :label="$t('Direction')"
                    hide-details
                    outlined
                  ></v-select>
                </v-flex>

                <v-flex xs12 md6>
                  <v-select
                    class="modern-field"
                    :items="classtip"
                    v-model="Bilet.GenelBilgileri.ClassTip"
                    clearable
                    item-text="text"
                    item-value="value"
                    :label="$t('Classt-Type')"
                    hide-details
                    outlined
                  ></v-select>
                </v-flex>

                <v-flex xs12>
                  <v-select
                    class="modern-field"
                    :items="fiyatturu"
                    hide-details
                    clearable
                    item-text="text"
                    item-value="value"
                    v-model="Bilet.GenelBilgileri.FiyatTur"
                    :label="$t('Price-Type')"
                    outlined
                  ></v-select>
                </v-flex>

                <v-flex xs12>
                  <v-textarea
                    class="modern-field"
                    :label="$t('Notes')"
                    v-model="Bilet.NotlarBilgileri.Aciklama2"
                    hide-details
                    outlined
                    rows="4"
                  ></v-textarea>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-flex>

        <v-flex xs12 md4 pa-2>
  <v-card class="content-card" flat>
    <div class="card-title">{{$t('Amount-Information')}}</div>

    <v-card-text>
      <v-layout row wrap>
        <v-flex xs12 md6>
          <parainput
            :isPositive="true"
            @odakkaybi="tahsilatdagitduzenle"
            :simge="getparabirimi()"
            :etiket="$t('Ticket-Amount')"
            v-model="Bilet.TutarBilgileri.Tutar.Tutar"
            :autocomplete="'autocomplete'"
          ></parainput>
        </v-flex>

        <v-flex xs12 md6>
         <v-text-field
  class="modern-field"
  :label="$t('Service-Code')"
  @blur="serviscodeControl"
  append-icon="search"
  @click:append="servisitemsgetir"
  maxlength="2"
  v-model="Bilet.TanimBilgileri.ServisKod"
  hide-details
  outlined
></v-text-field>
        </v-flex>

        <v-flex v-if="isDomesticTicket" xs12 md6>
          <parainput
            :isPositive="true"
            @odakkaybi="tahsilatdagitduzenle"
            :simge="getparabirimi()"
            :etiket="'YFF'"
            v-model="Bilet.TutarBilgileri.YFFTutar.YFFTutar"
            :autocomplete="'autocomplete'"
          ></parainput>
        </v-flex>

        <v-flex v-else xs12 md6>
          <parainput
            :isPositive="true"
            @odakkaybi="tahsilatdagitduzenle"
            :simge="getparabirimi()"
            :etiket="$t('Tax')"
            v-model="Bilet.TutarBilgileri.TaxTutar.TaxTutar"
            :autocomplete="'autocomplete'"
          ></parainput>
        </v-flex>

        <v-flex v-if="isDomesticTicket" xs12 md6>
          <parainput
            :isPositive="true"
            @odakkaybi="odakkaybiServisTahsilat"
            :simge="getparabirimi()"
            @input="ServisYuzdeAnalizKod"
            :etiket="$t('Service')"
            v-model="Bilet.TutarBilgileri.ServisTutar.ServisTutar"
            :autocomplete="'autocomplete'"
          ></parainput>
        </v-flex>

        <v-flex xs12 md6>
          <parainput
            :isPositive="true"
            @odakkaybi="tahsilatdagitduzenle"
            :simge="getparabirimi()"
            :etiket="$t('Landing-Tax')"
            v-model="Bilet.TutarBilgileri.AlanVergiTutar.AlanVergiTutar"
            :autocomplete="'autocomplete'"
          ></parainput>
        </v-flex>

        <v-flex xs12 md6>
          <parainput
            :isPositive="true"
            @odakkaybi="tahsilatdagitduzenle"
            :simge="getparabirimi()"
            :etiket="$t('Discount')"
            v-model="Bilet.TutarBilgileri.IskontoTutar.IskontoTutar"
            :autocomplete="'autocomplete'"
          ></parainput>
        </v-flex>

        <v-flex xs12 md6>
          <parainput
            :isPositive="true"
            @odakkaybi="tahsilatdagitduzenle"
            :simge="getparabirimi()"
            :etiket="$t('Penalty')"
            v-model="Bilet.TutarBilgileri.CezaTutar.CezaTutar"
            :autocomplete="'autocomplete'"
          ></parainput>
        </v-flex>

        <v-flex xs12 md6>
          <parainput
            :isPositive="true"
            @odakkaybi="tahsilatdagitduzenle"
            :simge="getparabirimi()"
            :etiket="'DFF'"
            v-model="Bilet.TutarBilgileri.ReserveTutar.ReserveTutar"
            :autocomplete="'autocomplete'"
          ></parainput>
        </v-flex>

        <v-flex xs12 md6>
          <parainput
            :isPositive="true"
            @odakkaybi="tahsilatdagitduzenle"
            :simge="getparabirimi()"
            :etiket="$t('MCO-PTA')"
            v-model="Bilet.TutarBilgileri.PtaTutar.PtaTutar"
            :autocomplete="'autocomplete'"
          ></parainput>
        </v-flex>

        <v-flex xs12 md6>
          <parainput
            :isPositive="true"
            :simge="getparabirimi()"
            :etiket="$t('Buying-Service-Amount')"
            v-model="Bilet.OdemeBilgileri.AlisServisTutar.AlisServisTutar"
            :autocomplete="'autocomplete'"
          ></parainput>
        </v-flex>
      </v-layout>
    </v-card-text>
  </v-card>
</v-flex>

<v-flex xs12 md4 pa-2>
  <v-card class="content-card" flat>
    <div class="card-title">{{$t('Additional-Information')}}</div>

    <v-card-text>
      <v-layout row wrap>
        <v-flex xs12>
          <v-text-field
            class="modern-field"
            :label="$t('Carbon-Emission')"
            v-model="Bilet.NotlarBilgileri.KarbonSalinimi"
            hide-details
            outlined
          ></v-text-field>
        </v-flex>

        <v-flex xs12>
          <tarihim
            :etiket="$t('Reservation-Date')"
            v-model="Bilet.NotlarBilgileri.DateofRes"
          ></tarihim>
        </v-flex>
      </v-layout>
    </v-card-text>
  </v-card>
</v-flex>


      </v-layout>
    </div>
  </v-card>
</section>

      

      <!-- UÇUŞ DETAY -->
      <section class="page-section">
        <div class="section-header section-header--with-action">
          <div>
            <h2>{{$t('Flight-Details')}}</h2>
          </div>

          <v-btn
            class="add-flight-btn"
            depressed
            color="info"
            :disabled="flightSegments.length >= 5"
            @click="addFlightSegment"
          >
            <v-icon left>add</v-icon>
            Uçuş Ekle
          </v-btn>
        </div>

        <div
          v-for="(segment, index) in flightSegments"
          :key="segment.id"
          class="flight-block"
        >
          <v-card class="content-card flight-card" flat>
            <div class="flight-grid">
              <div class="flight-visual">
                <div class="flight-overlay">{{ index + 1 }}. {{ $t('Flight') }}</div>
              </div>

              <div class="flight-fields">
                <v-layout row wrap>
                  <v-flex xs12 md2>
                    <tarihim
                      :etiket="$t('Flight-Date')"
                      :value="segment.UcusTarihi"
                      v-model="segment.UcusTarihi"
                      :defaultvalue="'no'"
                    ></tarihim>
                  </v-flex>

                  <v-flex xs12 md2>
                    <v-text-field
                      class="modern-field"
                      :label="$t('Flight-Time')"
                      v-model="segment.UcusSaat"
                      hide-details
                      outlined
                    ></v-text-field>
                  </v-flex>

                  <v-flex xs12 md2>
                    <v-text-field
                      class="modern-field"
                      :label="$t('Airline')"
                      v-model="segment.Havayolu"
                      hide-details
                      outlined
                    ></v-text-field>
                  </v-flex>

                  <v-flex xs12 md2>
                    <v-text-field
                      class="modern-field"
                      :label="$t('Flight-No')"
                      v-model="segment.UcusNo"
                      hide-details
                      outlined
                    ></v-text-field>
                  </v-flex>

                  <v-flex xs12 md2>
                    <v-text-field
                      class="modern-field"
                      :label="$t('Departure-TWO')"
                      v-model="segment.Kalkis"
                      hide-details
                      outlined
                    ></v-text-field>
                  </v-flex>

                  <v-flex xs12 md2>
                    <v-text-field
                      class="modern-field"
                      :label="$t('Arrival')"
                      v-model="segment.Varis"
                      hide-details
                      outlined
                    ></v-text-field>
                  </v-flex>

                  <v-flex xs12 md2>
                    <v-text-field
                      class="modern-field"
                      :label="$t('Class')"
                      v-model="segment.Class"
                      hide-details
                      outlined
                    ></v-text-field>
                  </v-flex>

                  <v-flex xs12 md2>
                    <v-text-field
                      class="modern-field"
                      :label="$t('Class-Type')"
                      v-model="segment.ClassTipi"
                      hide-details
                      outlined
                    ></v-text-field>
                  </v-flex>

                  <v-flex xs12 md2>
                    <tarihim
                      :etiket="$t('Arrival-Date')"
                      :value="segment.VarisTarihi"
                      v-model="segment.VarisTarihi"
                      :defaultvalue="'no'"
                    ></tarihim>
                  </v-flex>

                  <v-flex xs12 md2>
                    <v-text-field
                      class="modern-field"
                      :label="$t('Arrival-Time')"
                      v-model="segment.VarisSaati"
                      hide-details
                      outlined
                    ></v-text-field>
                  </v-flex>

                  <v-flex xs12 md2>
                    <v-text-field
                      class="modern-field"
                      :label="$t('Fare-Basis')"
                      v-model="segment.FareBases"
                      hide-details
                      outlined
                    ></v-text-field>
                  </v-flex>

                  <v-flex xs12 md2 class="flight-transfer">
                    <v-checkbox
                      :label="$t('Transfer-v2')"
                      v-model="segment.Aktarma"
                      hide-details
                      class="modern-check"
                    ></v-checkbox>
                  </v-flex>

                  <v-flex xs12 md3>
                    <v-text-field
                      class="modern-field"
                      :label="$t('Cabin-Baggage')"
                      v-model="segment.KabinBagaj"
                      hide-details
                      outlined
                    ></v-text-field>
                  </v-flex>

                  <v-flex xs12 md3>
                    <v-text-field
                      class="modern-field"
                      :label="$t('Baggage')"
                      v-model="segment.Bagaj"
                      hide-details
                      outlined
                    ></v-text-field>
                  </v-flex>

                  <v-flex xs12 md3>
                    <v-select
                      class="modern-field"
                      :items="mealStatusItems"
                      item-text="text"
                      item-value="value"
                      :label="$t('Meal-Status')"
                      v-model="segment.YemekDurumu"
                      hide-details
                      outlined
                    ></v-select>
                  </v-flex>

                  <v-flex xs12 md3>
                    <v-text-field
                      class="modern-field"
                      :label="$t('Meal-Description')"
                      v-model="segment.YemekAciklamasi"
                      hide-details
                      outlined
                    ></v-text-field>
                  </v-flex>

                  <v-flex xs12 md6>
                    <v-text-field
                      class="modern-field"
                      :label="$t('Cancellation-Terms')"
                      v-model="segment.IptalKosullari"
                      hide-details
                      outlined
                    ></v-text-field>
                  </v-flex>

                  <v-flex xs12 md6>
                    <v-text-field
                      class="modern-field"
                      :label="$t('Refund-Terms')"
                      v-model="segment.IadeKosullari"
                      hide-details
                      outlined
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </div>

              <div class="flight-actions" v-if="flightSegments.length > 1">
                <v-btn icon @click="removeFlightSegment(index)">
                  <v-icon color="red">delete</v-icon>
                </v-btn>
              </div>
            </div>
          </v-card>
        </div>
      </section>

      <v-dialog v-model="pdfDialog" max-width="420">
  <v-card>
    <v-card-title class="headline">
      {{ $t('PDF-Download') }}
    </v-card-title>

    <v-card-text>
      <div style="margin-bottom: 12px;">
        <strong>{{ $t('Should-the-amount-be-shown-on-the-PDF?') }}</strong>
      </div>

      <v-radio-group v-model="pdfShowAmount" row>
        <v-radio :label="$t('Show-Amount')" :value="true"></v-radio>
        <v-radio :label="$t('Hide-Amount')" :value="false"></v-radio>
      </v-radio-group>

      <v-select
        v-model="pdfLang"
        :items="pdfLangItems"
        item-text="text"
        item-value="value"
        :label="$t('Language-select')"
      ></v-select>
    </v-card-text>

    <v-card-actions>
      <v-spacer></v-spacer>

      <v-btn flat @click="pdfDialog = false">
        {{ $t('Cancel') }}
      </v-btn>

      <v-btn flat color="primary" @click="confirmPdfDownload()">
        {{ $t('Download') }}
      </v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>

<v-dialog v-model="faturadialog" persistent max-width="1000px">
  <v-card color="grey lighten-5">
    <v-toolbar dark color="info">
      <v-toolbar-title>{{ $t('Invoice-Entry') }}</v-toolbar-title>
    </v-toolbar>

    <v-card-text>
      <v-container grid-list-xs>
        <v-layout wrap>
          <div class="flex md4">
            <div class="card__text grey darken-1 white--text">
              <h3>{{ $t('General-Information') }}</h3>
            </div>

            <tarihim
               :etiket="$t('Invoice-Date')"
              :defaultvalue="'ok'"
              v-model="Fatura.FaturaTarih"
            ></tarihim>

            <v-layout>
              <v-text-field
                hide-details
                v-model="Fatura.FaturaSeri"
                :label="$t('Invoice-Serial')"
              ></v-text-field>

              <v-text-field
                hide-details
                v-model="Fatura.FaturaNo"
                :label="$t('Invoice-No')"
              ></v-text-field>
            </v-layout>

            <v-select
              :items="gibseri"
              v-model="Fatura.GibSeri"
              hide-details
              clearable
              item-text="Seri"
              item-value="Seri"
              :label="$t('Turkish-Revenue-Administration-Serial-No')"
            ></v-select>

            <v-text-field hide-details :label="$t('Invoice-Title-1')" v-model="Fatura.EFaturaBilgi.Unvani"></v-text-field>
            <v-text-field hide-details :label="$t('Invoice-Title-2')" v-model="Fatura.EFaturaBilgi.Unvani2"></v-text-field>
            <v-text-field hide-details :label="$t('Address-1')" v-model="Fatura.EFaturaBilgi.Adres1"></v-text-field>
            <v-text-field hide-details :label="$t('Address-2')" v-model="Fatura.EFaturaBilgi.Adres2"></v-text-field>
            <v-text-field hide-details :label="$t('Province_label')" v-model="Fatura.EFaturaBilgi.IlceSehir"></v-text-field>
            <v-text-field hide-details :label="$t('Invoice-E-mail')" v-model="Fatura.EFaturaBilgi.Email"></v-text-field>
            <v-text-field hide-details :label="$t('Taxcenter_label')" v-model="Fatura.EFaturaBilgi.VergiDairesi"></v-text-field>
            <v-text-field hide-details :label="$t('Taxnumber_label')" v-model="Fatura.EFaturaBilgi.VergiNo"></v-text-field>
            <v-text-field hide-details :label="$t('Identity-Number')" v-model="Fatura.EFaturaBilgi.TcKimlikNo"></v-text-field>
          </div>

          <div class="flex md4">
            <div class="card__text grey darken-1 white--text">
              <h3>{{ $t('For-Transactions-With-Turkish-ID') }}</h3>
            </div>

            <v-text-field hide-details :label="$t('Name_label')" v-model="Fatura.EFaturaBilgi.Adi"></v-text-field>
            <v-text-field hide-details :label="$t('Surname_label')" v-model="Fatura.EFaturaBilgi.Soyadi"></v-text-field>
            <v-text-field hide-details :label="$t('Title_label')" v-model="Fatura.EFaturaBilgi.TUnvani"></v-text-field>
            <v-text-field hide-details :label="$t('Othername_label')" v-model="Fatura.EFaturaBilgi.DigerAdi"></v-text-field>
            <v-text-field hide-details :label="$t('Suffixname_label')" v-model="Fatura.EFaturaBilgi.OnAdiEki"></v-text-field>

            <div class="card__text grey darken-1 white--text mt-3">
              <h3>{{ $t('Design-Options') }}</h3>
            </div>

            <v-checkbox
              :label="$t('Print-Invoice-with-Currency')"
              v-model="Fatura.Opsiyonlar.DovizliFatura"
            ></v-checkbox>

            <v-select
              :items="dizaynsec"
              v-model="Fatura.FaturaBilgi.FaturaID"
              hide-details
              clearable
              item-text="FaturaTabloAdi"
              item-value="FaturaId"
              :label="$t('Select-Design')"
              @change="faturaDizaynSec"
            ></v-select>
          </div>

          <div class="flex md4">
            <div class="card__text grey darken-1 white--text">
              <h3>{{ $t('Options-v2') }}</h3>
            </div>

            <v-checkbox
              :label="$t('Do-Not-Print-Passenger-Name')"
              v-model="Fatura.Opsiyonlar.YolcuGosterme"
            ></v-checkbox>

            <v-checkbox
              :label="$t('Do-Not-Print-Payment-Term')"
              v-model="Fatura.Opsiyonlar.OdemeVade"
            ></v-checkbox>

            <v-checkbox
              :label="$t('Print-Invoice-Details')"
              v-model="Fatura.Opsiyonlar.FaturaDetayBas"
            ></v-checkbox>
          </div>

          <v-flex xs12 mt-3>
            <v-text-field
              hide-details
              :label="$t('E-invoice-Footer-Disclosure')"
              v-model="Fatura.FaturaBilgi.FaturaDipAciklama"
            ></v-text-field>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card-text>

    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn flat color="primary" @click="faturadialog = false">{{ $t('Cancel') }}</v-btn>
      <v-btn flat color="primary" @click="faturala()">{{ $t('Invoice') }}</v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>

<v-dialog v-model="pdfLoading" persistent hide-overlay width="300">
  <v-card color="primary" dark>
    <v-card-text class="pa-4" style="display:flex; align-items:center; gap:12px;">
      <v-progress-circular indeterminate color="white" size="28"></v-progress-circular>
      <span>{{ $t('Please-wait-PDF-is-being-prepared') }}</span>
    </v-card-text>
  </v-card>
</v-dialog>

<v-dialog v-model="dialoghydegistir" persistent max-width="400px">
  <v-card color="grey lighten-5">
    <v-toolbar dark color="info">
      <v-toolbar-title>{{ $t('Change-Airline-Code') }}</v-toolbar-title>
      <v-spacer></v-spacer>
    </v-toolbar>

    <v-card-text>
      <hykoddegistircomp v-model="vmodelhyKod"></hykoddegistircomp>
    </v-card-text>

    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="blue darken-1" flat @click="dialoghydegistir=false">{{ $t('Cancel') }}</v-btn>
      <v-btn color="blue darken-1" flat @click="havayoluKoddegistir()">{{ $t('Change') }}</v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>

<v-dialog v-model="dialogkisamesaj" width="500">
  <v-card>
    <v-toolbar dark color="info">
      <v-toolbar-title>{{ $t('Warning') }}!</v-toolbar-title>
    </v-toolbar>

    <v-card-text>
      {{ kisamesaj }}
    </v-card-text>

    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="primary" flat @click="dialogkisamesaj = false">
        {{ $t("cancel_button") }}
      </v-btn>
      <v-btn v-if="btnsilsor" color="primary" flat @click="biletsil()">
        {{ $t('OK') }}
      </v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>

<v-dialog persistent v-model="voiddialog" width="300">
  <v-card color="grey lighten-5">
    <v-toolbar dark color="info">
      <v-toolbar-title>{{ $t('Make-it-Void') }}</v-toolbar-title>
    </v-toolbar>

    <v-card-text>
      <v-form ref="formvoid" v-model="validvoid">
        <tarihim
          :rules="[v => !!v || $t('Please-select-a-date')]"
          :etiket="$t('Void-Date')"
          :defaultvalue="'ok'"
          :value="voidTarihi"
          :detaygizle="false"
          v-model="voidTarihi"
        ></tarihim>
      </v-form>
    </v-card-text>

    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="primary" flat @click="voiddialog = false">
        {{ $t("cancel_button") }}
      </v-btn>
      <v-btn color="primary" flat @click="voidislem()">
        {{ $t('Make-it-Void') }}
      </v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>

<v-dialog v-model="showLogModal" max-width="800px">
  <v-card>
    <v-card-title>{{ $t('Ticket-Change-Logs') }}</v-card-title>

    <v-card-text>
      <v-data-table
        :headers="logHeaders"
        :items="Bilet.DegisiklikLoglari || []"
        dense
        class="elevation-1"
      >
        <template slot="items" slot-scope="props">
          <td class="text-xs-left">{{ props.item.DegisiklikNo }}</td>
          <td class="text-xs-left">{{ props.item.AlanAdi }}</td>
          <td class="text-xs-left">{{ props.item.EskiDeger }}</td>
          <td class="text-xs-left">{{ props.item.YeniDeger }}</td>
          <td class="text-xs-left">{{ props.item.UserAdi }}</td>
          <td class="text-xs-left">{{ props.item.HistoryDate }}</td>
          <td class="text-xs-left">{{ props.item.HistoryTime }}</td>
          <td class="text-xs-left">{{ props.item.HistoryComputer }}</td>
        </template>
      </v-data-table>
    </v-card-text>

    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="primary" flat @click="showLogModal = false">{{ $t('Close') }}</v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>
    </v-form>
  </div>
</template>

<script>
import helpers from "@/components/app/customcomp/helpers.js"
import caricomp from '@/components/app/customcomp/caricomp.vue'
import kesenkisi from '../customcomp/kesenkisi'
import tarihim from '../customcomp/tarihim'
import parainput from '../customcomp/parainput'
import notlar from "@/components/app/bilet/partpage/notlar.vue"
import duzyaziinput from '@/components/app/customcomp/duzyaziinput.vue'
import sayiinput from '@/components/app/customcomp/sayiinput.vue'
import tarihinput from '@/components/app/customcomp/tarihim.vue'
import loadingcomp from "@/components/app/customcomp/loadingcomp"
import hatadialog from "@/components/app/coper/comp/hatadialog.vue"
import snackbarcomp from "@/components/app/customcomp/snackbarcomp"
import yenibiletno from "@/components/app/bilet/partpage/yenibiletdialog1.vue"
import auth from '../../../api/auth'
import hykoddegistircomp from "@/components/app/bilet/partpage/hykod.vue"

export default {
  components: {
    caricomp,
    kesenkisi,
    tarihim,
    parainput,
    notlar,
    duzyaziinput,
    sayiinput,
    tarihinput,
    loadingcomp,
    hatadialog,
    snackbarcomp,
    yenibiletno,
    hykoddegistircomp
    
  },
  data() {
    return {
      faturadialog: false,
dizaynsec: [],
xsltitems: [],
eFaturaBilgi: 0,
earsivseridurum: 0,
gibseri: [],

Fatura: {
  SirketKodu: null,
  FaturaTarih: null,
  FaturaSeri: null,
  FaturaNo: null,
  GibSeri: null,

  BiletBilgi: {
    SirketKodu: null,
    BiletNo: null,
    FormNo: null,
    OdemeTarihi: null,
    CariKod: null,
    NetTutar: 0
  },

  EFaturaBilgi: {
    Unvani: null,
    Unvani2: null,
    Adres1: null,
    Adres2: null,
    IlceSehir: null,
    Email: null,
    VergiDairesi: null,
    VergiNo: null,
    TcKimlikNo: null,
    Adi: null,
    Soyadi: null,
    TUnvani: null,
    DigerAdi: null,
    OnAdiEki: null
  },

  FaturaBilgi: {
    FaturaTip: 'O',
    FaturaID: null,
    FaturaXSLTID: null,
    FaturaPdfID: 0,
    FaturaDipAciklama: null
  },

  Opsiyonlar: {
    YolcuGosterme: false,
    DovizliFatura: false,
    FaturaDetayBas: false,
    OdemeVade: false,
    UnvanAdres: false,
    FaturaTekSatir: false,
    OdemeSekliGrup: false
  },

  EArsivBilgi: {
    GonderimSekli: null,
    InternetSatis: null,
    WebAdresi: null,
    OdemeSekli: null,
    OdemeSekliAciklama: null,
    OdemeAraci: null,
    OdemeTarihi: null
  },

  DovizBilgi: {
    EDovizTipi: null,
    EKur: 0,
    DDovizTipi: null,
    DKur: 0
  }
},
      validvoid: true,
voiddialog: false,
voidTarihi: null,

dialoghydegistir: false,
dialogkisamesaj: false,
kisamesaj: '',
btnsilsor: false,

showLogModal: false,
logHeaders: [
  { text: 'No', value: 'DegisiklikNo' },
  { text: this.$t('Field-Name'), value: 'AlanAdi' },
  { text: this.$t('Old-Value'), value: 'EskiDeger' },
  { text: this.$t('New-Value'), value: 'YeniDeger' },
  { text: this.$t('User'), value: 'UserAdi' },
  { text: this.$t('Updated-Date'), value: 'HistoryDate' },
  { text: this.$t('Updated-Time'), value: 'HistoryTime' },
  { text: this.$t('Updated-Computer'), value: 'HistoryComputer' }
],

vmodelhyKod: {
  HavaYoluKodu: null,
  UcusTipi: null,
  AcenteKodu: null
},
      pdfDialog: false,
pdfLang: "tr",
pdfShowAmount: true,
pdfLoading: false,
pdfLangItems: [
  { text: "Türkçe", value: "tr" },
  { text: "English", value: "en" },
  { text: "Deutsch", value: "de" }
],

sayfayetki: {
  Screen: false,
  Update: true,
  Save: true,
  Delete: true,
  Status: false,
  Message: null,
  islem: 0
},

voidbtn: false,
iadebtn: false,
faturabtn: false,
faturanovarise: false,
  valid: true,
  loadingvmodel: false,
  snackbar: false,
  text1: '',
  PB: "TRY",
  guncellebtngorunum: false,
  caricompitems: null,
  yeniKayitDialog: false,
  counter: 0,

  itemssablon: [],
  itemsprofil: [],
  sablonobjeler: [],
  Sablon: {
    TemplateID: null,
    ProfilID: null
  },

  servisdialog: false,
  servisitems: [],
  servisheaders: [
    { text: this.$t('Code'), value: 'Kod' },
    { text: this.$t('Description'), value: 'Aciklama' },
    { text: this.$t('Amount'), value: 'Tutar' },
    { text: this.$t('Currency'), value: 'DovizKod' }
  ],
  servisTutarManuel: false,
  servisclass: {
    SirketKodu: '',
    Cari: {
      Kod: null
    },
    Parkurlar: {
      Parkur1: '',
      Parkur2: '',
      Parkur3: '',
      Parkur4: '',
      Parkur5: ''
    },
    Hat: '',
    DefaultKontrol: false
  },

  itemsKayitTipi: helpers.getBiletKayitTipi,

  biletyon: [
    { text: this.$t('One-Way'), value: 'T' },
    { text: this.$t('round-trip'), value: 'C' }
  ],

  classtip: [
    { text: 'Economy', value: 'E' },
    { text: 'Business', value: 'B' }
  ],

  fiyatturu: [
    { text: 'AD-' + this.$t('Adult'), value: 'AD' },
    { text: 'CH-' + this.$t('Child'), value: 'CH' },
    { text: 'IN-' + this.$t('Baby'), value: 'IN' }
  ],

  mealStatusItems: [
    { text: this.$t('None'), value: 'none' },
    { text: this.$t('Standart'), value: 'standard' },
    { text: this.$t('Special'), value: 'special' }
  ],

  Bilet: {
    GenelBilgileri: {
      HesKodu: null,
      RecordTypeInfo: {
        RecordTypeID: 0,
        RecordTypeExp: null
      },
      ArkmanUsers: '',
      SirketKodu: '',
      BiletNo: '',
      Formno: '',
      HavaYoluKodu: null,
      UcusTipi: 'I',
      SiparisNo: 0,
      MusteriKodu: {
        Kod: '',
        Uyari: '',
        BilgiNotu: ''
      },
      KesenKisi: '',
      YolcuAdi: '',
      Parkurlar: {
        Parkur1: '',
        Parkur2: '',
        Parkur3: '',
        Parkur4: '',
        Parkur5: ''
      },
      Classlar: {
        Class1: '',
        Class2: '',
        Class3: '',
        Class4: '',
        Class5: ''
      },
      FiyatTur: 'AD',
      Referans: {
        Kod: ''
      },
      YolcuAdet: 1,
      Baglantili: false,
      PnrNo: '',
      RezervasyonVeren: '',
      RezervasyonAlan: '',
      Status: 'S',
      Acente: '',
      AcenteKodu: '',
      ExBiletNo: '',
      ExBiletHY: '',
      ClassTip: 'E',
      BiletYon: 'T',
      DepartmanKod: '',
      Crs: 'Manuel',
      Masraf: {
        Code: ''
      },
      Email: '',
      BiletTel: '',
      OpenBilet: false
    },

    TarihBilgileri: {
      KesimTarihi: null,
      SatisTarihi: null,
      IptalTarihi: null,
      IadeTarihi: null,
      OdemeTarihi: null,
      OpenTarihi: null
    },

    UcusBilgileri: {
      UcusTarihi: null,
      UcusNo1: null,
      UcusNo2: null,
      UcusDonusTarihi: null,
      UcusDonusNo1: null,
      UcusDonusNo2: null,
      UcusListesi: []
    },

    FaturaBilgileri: {
      FaturaTarihi: null,
      FaturaSeri: null,
      FaturaNo: 0,
      EfaturaBilgileri: {
        FaturaNo: null,
        Guid: null,
        FaturaDurumu: null,
        SanalFaturaNo: null,
        GercekFaturaNo: null,
        BasimTarihi: null,
        Kullanici: null,
        GonderimSekli: 0,
        InternetSatis: 0,
        WebAdresi: null,
        OdemeSekli: 0,
        OdemeSekliAciklama: null,
        OdemeAraci: null,
        OdemeTarihi: null
      },
      AlisFaturaNo: null,
      ProformaSeri: null,
      ProformaNo: 0,
      ProformaTarihi: null,
      SatisFaturaID: null,
      MaliyetFaturaID: null,
      AlisFaturaTarihi: null,
      AlisFatNo: null,
      FaturaOtomatik: 0,
      IstinaKod: null,
      KdvKod: null
    },

    TutarBilgileri: {
      Doviz: {
        DovizKod: 'TRY'
      },
      Kur: 1,
      NetTutar: {
        NetTutar: 0,
        NetTutarSatisDoviz: 0,
        NetTutarAlisDoviz: 0,
        NetTutarKdv: 0
      },
      Tutar: {
        Tutar: 0,
        TutarSatisDoviz: 0,
        TutarAlisDoviz: 0,
        TutarKdv: 0
      },
      PtaTutar: {
        PtaTutar: 0,
        PtaSatisDoviz: 0,
        PtaAlisDoviz: 0,
        PtaKdv: 0
      },
      AlanVergiTutar: {
        AlanVergiTutar: 0,
        AlanVergiSatisDoviz: 0,
        AlanVergiAlisDoviz: 0,
        AlanVergiKdv: 0
      },
      CharterTutar: {
        CharterTutar: 0,
        CharterSatisDoviz: 0,
        CharterAlisDoviz: 0,
        CharterKdv: 0
      },
      YFFTutar: {
        YFFTutar: 0,
        YFFDoviz: 0,
        YFFKdv: 0
      },
      ServisTutar: {
        ServisTutar: 0,
        ServisDoviz: 0,
        ServisKdv: 0
      },
      DigerServisTutar: {
        DigerServisTutar: 0,
        DigerServisDoviz: 0,
        DigerServisKdv: 0
      },
      IskontoTutar: {
        IskontoYuzde: 0,
        IskontoTutar: 0,
        IskontoDoviz: 0,
        IskontoKdv: 0
      },
      TaxTutar: {
        TaxTutar: 0,
        TaxSatisDoviz: 0,
        TaxAlisDoviz: 0,
        TaxKdv: 0
      },
      CezaTutar: {
        CezaTutar: 0,
        CezaSatisTutar: 0,
        CezaAlisTutar: 0,
        CezaKdv: 0
      },
      KaTutar: {
        KaTutar: 0,
        KaDoviz: 0,
        KaKdv: 0
      },
      ReserveTutar: {
        ReserveYuzde: 0,
        ReserveTutar: 0,
        ReserveDoviz: 0,
        ReserveKdv: 0
      },
      TevkifatTutar: {
        TevkifatKodu: null,
        TevkifatOran: 0,
        TevkifatTutar: 0
      }
    },

    OdemeBilgileri: {
      SatisSekli: 'K',
      KomisyonTip: '',
      HYOran: 0,
      GSAOran: 0,
      KrediliTutar: 0,
      KrediliDoviz: 0,
      PesinTutar: 0,
      PesinDoviz: 0,
      KrediKartTutar: 0,
      KrediKartDoviz: 0,
      KrediKartBilgi: {
        KrediKartNo: '',
        KrediKartAy: '',
        KrediKartYil: '',
        KrediKartCins: '',
        KrediKartTip: ''
      },
      AlisServisTutar: {
        AlisServisTutar: 0,
        AlisServisDoviz: 0,
        AlisServisKdv: 0
      },
      HavaYoluTutar: 0,
      HavaYoluKdv: 0,
      Csc: false,
      BankaBilgileri: {
        PosKod: {
          BankaPosID: 0,
          SirketKodu: 0,
          PosKodu: '',
          Aciklama: '',
          MuhasebeKodlar: {
            MuhasebeKodu: '',
            CMuhasebeKodu: '',
            FDisAktarimCariKodu: '',
            FDisAktarimMuhKodu: '',
            CDisAktarimCariKodu: '',
            CDisAktarimMuhKodu: '',
            ServisMuhasebeKodu: '',
            ServisDisAktarimCariKodu: '',
            ServisDisAktarimMuhKodu: ''
          },
          Parametreler: {
            ID: 0,
            Banka: {
              BankaID: 0,
              SirketKodu: 0,
              BankaKod: '',
              BankaAdi: '',
              Cari: {
                Kod: ''
              },
              BankaKisaKod: '',
              Tip: 0
            },
            PosMuhKodu: '',
            PuanCariKodu: '',
            SozlesmeBaslangic: null,
            SozlesmeBitis: null,
            Aktif: '',
            VadeTip: '',
            UyelikTutar: 0,
            UyelikOran: 0,
            Kota: 0,
            KotaGun: 0,
            KotaCezaTutar: 0,
            KotaCezaOran: 0,
            VadeSabitGun: 0,
            VadeFarkSabit: 0,
            KotaKod: '',
            TerminalID: '',
            UyeIsYeriID: '',
            UserName: '',
            UserPass: '',
            PosType: 0,
            StoreKey: ''
          }
        },
        ServisPosKod: {
          BankaPosID: 0,
          SirketKodu: 0,
          PosKodu: '',
          Aciklama: '',
          MuhasebeKodlar: {
            MuhasebeKodu: '',
            CMuhasebeKodu: '',
            FDisAktarimCariKodu: '',
            FDisAktarimMuhKodu: '',
            CDisAktarimCariKodu: '',
            CDisAktarimMuhKodu: '',
            ServisMuhasebeKodu: '',
            ServisDisAktarimCariKodu: '',
            ServisDisAktarimMuhKodu: ''
          },
          Parametreler: {
            ID: 0,
            Banka: {
              BankaID: 0,
              SirketKodu: 0,
              BankaKod: '',
              BankaAdi: '',
              Cari: {
                Kod: ''
              },
              BankaKisaKod: '',
              Tip: 0
            },
            PosMuhKodu: '',
            PuanCariKodu: '',
            SozlesmeBaslangic: null,
            SozlesmeBitis: null,
            Aktif: '',
            VadeTip: '',
            UyelikTutar: 0,
            UyelikOran: 0,
            Kota: 0,
            KotaGun: 0,
            KotaCezaTutar: 0,
            KotaCezaOran: 0,
            VadeSabitGun: 0,
            VadeFarkSabit: 0,
            KotaKod: '',
            TerminalID: '',
            UyeIsYeriID: '',
            UserName: '',
            UserPass: '',
            PosType: 0,
            StoreKey: ''
          },
          Taksitler: []
        },
        ServisPosTutar: 0,
        TaksitKod: null,
        ServisTaksitKod: null,
        TaksitKodLabel: null,
        ServisTaksitKodLabel: null,
        PuanTutar: 0
      },
      Slipkod: '',
      MakbuzNo: ''
    },

    DigerBilgileri: {
      SaveTime: null,
      Entegre: false,
      BiletTanim: '',
      eservedTutar1: 0,
      ExIcDis: '',
      EntegreTablo: '',
      GrossTutar: 0,
      CharterPtaKodu: '',
      pArkmanEntegre: '',
      PinKodu: '',
      RezervasyonID: '',
      SiparisID: '',
      CKLogID: 0,
      ParkurTip: '',
      DServisKod1: '',
      DServisKod2: '',
      KKEnt: '',
      SatisSapEntegre: '',
      MaliyetSapEntegre: '',
      KisiID: 0,
      UserID: 0
    },

    TanimBilgileri: {
      ServisKod: '',
      AnalizKod: {
        SirketKodu: 0,
        AnalizKod: '',
        AnalizAdi: '',
        AnalizTutar: 0,
        AnalizOran: 0
      },
      AnalizTutar: 0,
      AnalizDoviz: 0,
      AnalizKod1: {
        SirketKodu: 0,
        AnalizKod: '',
        AnalizAdi: '',
        AnalizTutar: 0,
        AnalizOran: 0
      },
      AnalizTutar1: 0,
      AnalizDoviz1: 0,
      TcKimlikNolar: {
        TcNo1: '',
        TcNo2: '',
        TcNo3: '',
        TcNo4: '',
        TcNo5: ''
      },
      Aciklamalar: {
        Aciklama1: '',
        Aciklama2: '',
        Aciklama3: '',
        Aciklama4: '',
        Aciklama5: '',
        Aciklama6: '',
        Aciklama7: ''
      },
      MilKodu: {
        MilKoduOde: '',
        MilKoduYolcu: '',
        MilAdet: 0,
        MilTutar: 0
      },
      MusteriPersonel: {
        PersonelUcan: {
          ID: 0,
          SirketKodu: 0,
          SirketAdi: '',
          MasrafYeri: '',
          SicilNo: '',
          Adi: '',
          Soyadi: '',
          CalismaYeri: '',
          Bolum: '',
          IcSeyahat: '',
          DisSeyahat: '',
          IsAlani: '',
          Siparis: '',
          Cari: {
            Kod: ''
          },
          KapatAc: false,
          Email: '',
          Tel: ''
        },
        PersonelSponsor: {
          ID: 0,
          SirketKodu: 0,
          SirketAdi: '',
          MasrafYeri: '',
          SicilNo: '',
          Adi: '',
          Soyadi: '',
          CalismaYeri: '',
          Bolum: '',
          IcSeyahat: '',
          DisSeyahat: '',
          IsAlani: '',
          Siparis: '',
          Cari: {
            Kod: ''
          },
          KapatAc: false,
          Email: '',
          Tel: ''
        }
      },
      YolcuCrm: {
        CrmYolcu: {
          Ref: 0,
          Adi: '',
          Soyadi: '',
          Tel: '',
          Gsm: '',
          Email: '',
          TCKimlikNo: '',
          ID: 0
        },
        CrmRezervasyon: {
          Ref: 0,
          Adi: '',
          Soyadi: '',
          Tel: '',
          Gsm: '',
          Email: '',
          TCKimlikNo: '',
          ID: 0
        }
      },
      ProfilID: 0,
      SablonID: 0,
      Bolum: '',
      EventID: '',
      ExAciklamalar: {
        ID: 0,
        SirketKodu: 0,
        Biletno: '',
        HavayoluKod: '',
        EmployeeId: '',
        DepartmentId: '',
        CostCenter: '',
        ClientId: '',
        DkNumber: '',
        WwId: '',
        BusinessUnit: '',
        CompanyCode: '',
        SiteCode: '',
        PurposeOt: '',
        PcNumber: '',
        NoHotelBc: '',
        TripApprover: ''
      }
    },

    AyrintiOdemeBilgileri: [],

    NotlarBilgileri: {
      SirketKodu: 0,
      BiletNo: '',
      FormNo: '',
      Aciklama1: '',
      Aciklama2: '',
      Segment1: '',
      Segment2: '',
      Segment3: '',
      Segment4: '',
      Segment5: '',
      RefFare: 0,
      LowFare: 0,
      RealCode: '',
      DateofRes: null,
      MarketCode: '',
      TicketSuffix: '',
      VendorNumber: '',
      ReasonCode: '',
      CRSGDS: '',
      SubPruductCode: '',
      TicketTypeInd: false,
      TourCode: '',
      AlternatifTutar1: 0,
      AlternatifTutar2: 0,
      AlternatifTutar3: 0,
      Anlasmali: false,
      Esnek: false,
      KarbonSalinimi: 0,
      Mil1: 0,
      Mil2: 0,
      Mil3: 0,
      Mil4: 0,
      AirlineFile: ''
    },

    TaksitBilgileri: {
      ID: 0,
      SirketKodu: 0,
      BiletNo: '',
      HavaYoluKodu: '',
      MakbuzNo: '',
      CCNo1: '',
      Tip1: '',
      Ay1: 0,
      Yil1: 0,
      Tutar1: 0,
      Iade1: 0,
      Taksit1: 0,
      TVade1: null,
      PosKodu1: '',
      CCNo2: '',
      Tip2: '',
      Ay2: 0,
      Yil2: 0,
      Tutar2: 0,
      Iade2: 0,
      Taksit2: 0,
      TVade2: null,
      PosKodu2: '',
      CCNo3: '',
      Tip3: '',
      Ay3: 0,
      Yil3: 0,
      Tutar3: 0,
      Iade3: 0,
      Taksit3: 0,
      TVade3: null,
      PosKodu3: '',
      CCNo4: '',
      Tip4: '',
      Ay4: 0,
      Yil4: 0,
      Tutar4: 0,
      Iade4: 0,
      Taksit4: 0,
      TVade4: null,
      PosKodu4: '',
      PesinSatisTutari: 0,
      PesinIadeTutari: 0,
      SlipKod1: '',
      SlipKod2: '',
      SlipKod3: '',
      SlipKod4: '',
      OdemeFaturaId: '',
      OdemeSapEntegre: ''
    }
  },

  UcusList: [],

  UcusListesi: {
    Ucus1: {
      Aktarma: false,
      BiletNo: '',
      FareBases: 0,
      Formno: '',
      ID: '',
      Parkur: '',
      ParkurNo: '',
      SirketKodu: '',
      UcusClass: '',
      UcusClassTip: null,
      UcusHY: '',
      UcusNo: '',
      UcusSaat: '',
      UcusTarihi: null,
      VarisSaat: '',
      VarisTarihi: null,
      ExAciklamaUcus: {
        UcusIndex: 1,
        KabinBagaj: '',
        Bagaj: '',
        YemekDurumu: null,
        YemekAciklama: '',
        IptalSartlari: '',
        IadeSartlari: ''
      }
    },
    Ucus2: {
      Aktarma: false,
      BiletNo: '',
      FareBases: 0,
      Formno: '',
      ID: '',
      Parkur: '',
      ParkurNo: '',
      SirketKodu: '',
      UcusClass: '',
      UcusClassTip: null,
      UcusHY: '',
      UcusNo: '',
      UcusSaat: '',
      UcusTarihi: null,
      VarisSaat: '',
      VarisTarihi: null,
      ExAciklamaUcus: {
        UcusIndex: 2,
        KabinBagaj: '',
        Bagaj: '',
        YemekDurumu: null,
        YemekAciklama: '',
        IptalSartlari: '',
        IadeSartlari: ''
      }
    },
    Ucus3: {
      Aktarma: false,
      BiletNo: '',
      FareBases: 0,
      Formno: '',
      ID: '',
      Parkur: '',
      ParkurNo: '',
      SirketKodu: '',
      UcusClass: '',
      UcusClassTip: null,
      UcusHY: '',
      UcusNo: '',
      UcusSaat: '',
      UcusTarihi: null,
      VarisSaat: '',
      VarisTarihi: null,
      ExAciklamaUcus: {
        UcusIndex: 3,
        KabinBagaj: '',
        Bagaj: '',
        YemekDurumu: null,
        YemekAciklama: '',
        IptalSartlari: '',
        IadeSartlari: ''
      }
    },
    Ucus4: {
      Aktarma: false,
      BiletNo: '',
      FareBases: 0,
      Formno: '',
      ID: '',
      Parkur: '',
      ParkurNo: '',
      SirketKodu: '',
      UcusClass: '',
      UcusClassTip: null,
      UcusHY: '',
      UcusNo: '',
      UcusSaat: '',
      UcusTarihi: null,
      VarisSaat: '',
      VarisTarihi: null,
      ExAciklamaUcus: {
        UcusIndex: 4,
        KabinBagaj: '',
        Bagaj: '',
        YemekDurumu: null,
        YemekAciklama: '',
        IptalSartlari: '',
        IadeSartlari: ''
      }
    },
    Ucus5: {
      Aktarma: false,
      BiletNo: '',
      FareBases: 0,
      Formno: '',
      ID: '',
      Parkur: '',
      ParkurNo: '',
      SirketKodu: '',
      UcusClass: '',
      UcusClassTip: null,
      UcusHY: '',
      UcusNo: '',
      UcusSaat: '',
      UcusTarihi: null,
      VarisSaat: '',
      VarisTarihi: null,
      ExAciklamaUcus: {
        UcusIndex: 5,
        KabinBagaj: '',
        Bagaj: '',
        YemekDurumu: null,
        YemekAciklama: '',
        IptalSartlari: '',
        IadeSartlari: ''
      }
    }
  },

  flightSegments: [
    {
      id: 1,
      UcusTarihi: null,
      UcusSaat: '',
      Havayolu: '',
      UcusNo: '',
      Kalkis: '',
      Varis: '',
      Class: '',
      ClassTipi: '',
      VarisTarihi: null,
      VarisSaati: '',
      FareBases: '',
      Aktarma: false,
      KabinBagaj: '',
      Bagaj: '',
      YemekDurumu: null,
      YemekAciklamasi: '',
      IptalKosullari: '',
      IadeKosullari: ''
    }
  ],

  faturalansinmi: true
}
  },
mounted() {
  if (this.$route.query.isl == 'yeni') {
    this.yeniKayitDialog = true;
  }
  if (this.$route.query.isl == 'get') {
    this.ticketGetir();
  }

  if (this.$route.query.isl == 'voidget') {
    this.voidTicketGetir();
  }
},

computed: {
  isDomesticTicket() {
    var ucusTipi = this.Bilet && this.Bilet.GenelBilgileri
      ? String(this.Bilet.GenelBilgileri.UcusTipi || '').toUpperCase()
      : ''

    return ucusTipi === 'I' || ucusTipi === 'İ'
  }
},

  methods: {
    iadeKaydiVarMi() {
  var tarihBilgileri = this.Bilet && this.Bilet.TarihBilgileri
    ? this.Bilet.TarihBilgileri
    : {}

  var iadeTarihi = tarihBilgileri.IadeTarihi

  if (
    iadeTarihi &&
    String(iadeTarihi).indexOf('0001-01-01') !== 0 &&
    String(iadeTarihi).indexOf('0000-00-00') !== 0
  ) {
    return true
  }

  var taksit = this.Bilet && this.Bilet.TaksitBilgileri
    ? this.Bilet.TaksitBilgileri
    : {}

  return Number(taksit.PesinIadeTutari || 0) > 0 ||
    Number(taksit.Iade1 || 0) > 0 ||
    Number(taksit.Iade2 || 0) > 0 ||
    Number(taksit.Iade3 || 0) > 0 ||
    Number(taksit.Iade4 || 0) > 0
},
ensureObj(parent, key, fallback) {
  if (!parent[key]) {
    this.$set(parent, key, fallback);
  }

  return parent[key];
},

normalizeTicketForRender() {
  if (!this.Bilet) {
    this.Bilet = {};
  }

  var genel = this.ensureObj(this.Bilet, "GenelBilgileri", {});
  this.ensureObj(genel, "RecordTypeInfo", {
    RecordTypeID: 0,
    RecordTypeExp: null
  });

  this.ensureObj(genel, "MusteriKodu", {
    Kod: "",
    Uyari: "",
    BilgiNotu: ""
  });

  this.ensureObj(genel, "Parkurlar", {
    Parkur1: "",
    Parkur2: "",
    Parkur3: "",
    Parkur4: "",
    Parkur5: ""
  });

  this.ensureObj(genel, "Classlar", {
    Class1: "",
    Class2: "",
    Class3: "",
    Class4: "",
    Class5: ""
  });

  this.ensureObj(genel, "Referans", {
    Kod: ""
  });

  this.ensureObj(genel, "Masraf", {
    Code: ""
  });

  var tarih = this.ensureObj(this.Bilet, "TarihBilgileri", {});
  this.ensureObj(this.Bilet, "UcusBilgileri", {
    UcusListesi: []
  });

  var fatura = this.ensureObj(this.Bilet, "FaturaBilgileri", {});
  if (fatura.FaturaNo === null || fatura.FaturaNo === undefined) {
    this.$set(fatura, "FaturaNo", 0);
  }

  this.ensureObj(fatura, "EfaturaBilgileri", {
    FaturaNo: null,
    Guid: null,
    FaturaDurumu: null,
    SanalFaturaNo: null,
    GercekFaturaNo: null,
    BasimTarihi: null,
    Kullanici: null,
    GonderimSekli: 0,
    InternetSatis: 0,
    WebAdresi: null,
    OdemeSekli: 0,
    OdemeSekliAciklama: null,
    OdemeAraci: null,
    OdemeTarihi: null
  });

  var tutar = this.ensureObj(this.Bilet, "TutarBilgileri", {});
  this.ensureObj(tutar, "Doviz", { DovizKod: "TRY" });
  this.ensureObj(tutar, "NetTutar", { NetTutar: 0, NetTutarSatisDoviz: 0 });
  this.ensureObj(tutar, "Tutar", { Tutar: 0 });
  this.ensureObj(tutar, "YFFTutar", { YFFTutar: 0 });
  this.ensureObj(tutar, "ServisTutar", { ServisTutar: 0 });
  this.ensureObj(tutar, "AlanVergiTutar", { AlanVergiTutar: 0 });
  this.ensureObj(tutar, "TaxTutar", { TaxTutar: 0 });
  this.ensureObj(tutar, "IskontoTutar", { IskontoTutar: 0 });
  this.ensureObj(tutar, "CezaTutar", { CezaTutar: 0 });
  this.ensureObj(tutar, "ReserveTutar", { ReserveTutar: 0 });
  this.ensureObj(tutar, "PtaTutar", { PtaTutar: 0 });

  var odeme = this.ensureObj(this.Bilet, "OdemeBilgileri", {});
  this.ensureObj(odeme, "AlisServisTutar", { AlisServisTutar: 0 });

  this.ensureObj(this.Bilet, "NotlarBilgileri", {
    Aciklama2: "",
    KarbonSalinimi: 0,
    DateofRes: null
  });

  this.ensureObj(this.Bilet, "TanimBilgileri", {
    ServisKod: ""
  });

  this.ensureObj(this.Bilet, "DigerBilgileri", {
    PinKodu: ""
  });

  this.ensureObj(this.Bilet, "DegisiklikLoglari", []);
},


   faturadialogackontrol() {
  if (!this.Bilet || !this.Bilet.GenelBilgileri || !this.Bilet.GenelBilgileri.BiletNo) {
    this.text1 = this.$t('Ticket-Must-Be-Selected-Or-Saved-First')
    this.snackbar = true
    return
  }

  this.faturadialogac()
},

faturadialogac() {
  var cari = this.Bilet && this.Bilet.GenelBilgileri
    ? this.Bilet.GenelBilgileri.MusteriKodu
    : null

  if (!cari || !cari.Kod) {
    this.text1 = this.$t('Please-select-your-current-code-before-invoicing.')
    this.snackbar = true
    return
  }

  var credentials = JSON.parse(window.localStorage.getItem('credentials'))
  var isEFatura = Number(this.eFaturaBilgi) === 1

  this.Fatura.SirketKodu = credentials.SirketKodu
  this.Fatura.FaturaTip = 'O'
  this.Fatura.FaturaBilgi.FaturaTip = 'O'
  this.Fatura.FaturaTarih = this.Bilet.FaturaBilgileri.FaturaTarihi || this.Bilet.TarihBilgileri.SatisTarihi
  this.Fatura.FaturaSeri = null
  this.Fatura.FaturaNo = null
  this.Fatura.GibSeri = null
  this.Fatura.Bilet = this.Bilet

  var designParams = {
    SirketKodu: credentials.SirketKodu,
    FaturaTip: 'O',
    DovizliFatura: Boolean(this.Fatura.Opsiyonlar.DovizliFatura),
    TumFiltre: true,
    HatTipi: !this.isDomesticTicket
  }

  this.faturadialog = true

  this.$http.post(auth.API_URL + 'api/TicketInvoice/InvoiceMainTableList', designParams, {
    headers: { Authorization: 'Bearer ' + auth.getAuthHeader() }
  }).then((response) => {
    this.dizaynsec = response.body || []

    if (this.dizaynsec.length === 1) {
      this.Fatura.FaturaBilgi.FaturaID = this.dizaynsec[0].FaturaId
      this.faturaDizaynSec(this.Fatura.FaturaBilgi.FaturaID)
    }
  }, () => {
    this.text1 = this.$t('Service-Unavailable') + '-InvoiceMainTableList'
    this.snackbar = true
  })

  var gibParams = {
    CompanyCode: credentials.SirketKodu,
    PassiveControl: true
  }

  var serialEndpoint = isEFatura
    ? 'api/Definitions/GibSerialList'
    : 'api/Definitions/GibSerialEarchiveList'

  this.$http.post(auth.API_URL + serialEndpoint, gibParams, {
    headers: { Authorization: 'Bearer ' + auth.getAuthHeader() }
  }).then((response) => {
    this.gibseri = response.body || []

    if (this.gibseri.length === 1) {
      this.Fatura.GibSeri = this.gibseri[0].Seri
    }
  }, () => {
    this.text1 = this.$t('Service-Unavailable') + '-GibSerialList'
    this.snackbar = true
  })

  var lastBillParams = {
    SirketKodu: credentials.SirketKodu,
    EFaturaBilgi: isEFatura,
    EArsivBilgi: false,
    ParamKontrol: true,
    InternetSatis: this.Bilet.FaturaBilgileri.EfaturaBilgileri.InternetSatis
  }

  this.$http.post(auth.API_URL + 'api/TicketHelpers/GetLastBillNumber', lastBillParams, {
    headers: { Authorization: 'Bearer ' + auth.getAuthHeader() }
  }).then((response) => {
    if (response.body) {
      this.Fatura.FaturaSeri = response.body.FaturaSeri
      this.Fatura.FaturaNo = response.body.FaturaNo
    }
  }, () => {
    this.text1 = this.$t('Service-Unavailable') + '-GetLastBillNumber'
    this.snackbar = true
  })
},

faturaDizaynSec(faturaId) {
  var selected = (this.dizaynsec || []).find(function (item) {
    return Number(item.FaturaId) === Number(faturaId)
  })

  if (!selected) {
    this.Fatura.FaturaBilgi.FaturaXSLTID = null
    this.Fatura.FaturaBilgi.FaturaPdfID = 0
    return
  }

  this.Fatura.FaturaBilgi.FaturaXSLTID =
    selected.FaturaXsltId || selected.FaturaXSLTID || selected.XSLTID || null

  this.Fatura.FaturaBilgi.FaturaPdfID =
    selected.FaturaPdfID || selected.PdfID || 0
},

faturaEBDuzenle() {
  var genel = this.Bilet && this.Bilet.GenelBilgileri

  if (!genel || !genel.BiletNo) {
    this.text1 = this.$t('Ticket-Must-Be-Selected-Or-Saved-First')
    this.snackbar = true
    return
  }

  var url = '#/bilet/faturalibiletduzenle/id?' +
    'isl=edit' +
    '&hyolukod=' + encodeURIComponent(genel.HavaYoluKodu || '') +
    '&biletno=' + encodeURIComponent(genel.BiletNo) +
    '&ucustipi=' + encodeURIComponent(genel.UcusTipi || '')

  window.open(url, '_self')
},

faturala() {
  var credentials = JSON.parse(window.localStorage.getItem('credentials'))

  this.Fatura.SirketKodu = credentials.SirketKodu

  this.Fatura.BiletBilgi = this.Fatura.BiletBilgi || {}
  this.Fatura.EArsivBilgi = this.Fatura.EArsivBilgi || {}
  this.Fatura.DovizBilgi = this.Fatura.DovizBilgi || {}
  this.Fatura.EFaturaBilgi = this.Fatura.EFaturaBilgi || {}
  this.Fatura.FaturaBilgi = this.Fatura.FaturaBilgi || {}
  this.Fatura.Opsiyonlar = this.Fatura.Opsiyonlar || {}

  this.Fatura.BiletBilgi.SirketKodu = null
  this.Fatura.BiletBilgi.BiletNo = this.Bilet.GenelBilgileri.BiletNo
  this.Fatura.BiletBilgi.FormNo = this.Bilet.GenelBilgileri.Formno
  this.Fatura.BiletBilgi.UcusTip = this.Bilet.GenelBilgileri.UcusTipi
  this.Fatura.BiletBilgi.OdemeTarihi =
    this.Bilet.TarihBilgileri.OdemeTarihi ||
    this.Bilet.TarihBilgileri.SatisTarihi ||
    this.Fatura.FaturaTarih

  this.Fatura.BiletBilgi.CariKod = this.Bilet.GenelBilgileri.MusteriKodu
  this.Fatura.BiletBilgi.NetTutar = this.Bilet.TutarBilgileri.NetTutar.NetTutar

  this.Fatura.EFaturaBilgi.Unvani =
    this.Fatura.EFaturaBilgi.Unvani ||
    this.Bilet.GenelBilgileri.MusteriKodu.Unvan ||
    this.Bilet.GenelBilgileri.MusteriKodu.Isim ||
    ''

  this.Fatura.EFaturaBilgi.Unvani2 = this.Fatura.EFaturaBilgi.Unvani2 || ''
  this.Fatura.EFaturaBilgi.Adres1 = this.Fatura.EFaturaBilgi.Adres1 || ''
  this.Fatura.EFaturaBilgi.Adres2 = this.Fatura.EFaturaBilgi.Adres2 || null
  this.Fatura.EFaturaBilgi.IlceSehir = this.Fatura.EFaturaBilgi.IlceSehir || ''
  this.Fatura.EFaturaBilgi.Email = this.Fatura.EFaturaBilgi.Email || ''
  this.Fatura.EFaturaBilgi.VergiDairesi = this.Fatura.EFaturaBilgi.VergiDairesi || ''
  this.Fatura.EFaturaBilgi.VergiNo = this.Fatura.EFaturaBilgi.VergiNo || ''
  this.Fatura.EFaturaBilgi.TcKimlikNo = this.Fatura.EFaturaBilgi.TcKimlikNo || ''

  this.Fatura.FaturaBilgi.FaturaTip = 'O'

  var selectedXslt = null

  if (this.dizaynsec && this.dizaynsec.length > 0) {
    selectedXslt = this.dizaynsec.find(x =>
      x.FaturaId == this.Fatura.FaturaBilgi.FaturaID ||
      x.FaturaID == this.Fatura.FaturaBilgi.FaturaID ||
      x.FaturaId == this.Fatura.FaturaBilgi.FaturaId
    )
  }

  if (selectedXslt) {
    this.Fatura.FaturaBilgi.FaturaXSLTID =
      selectedXslt.FaturaXsltId ||
      selectedXslt.FaturaXSLTID ||
      selectedXslt.XSLTID ||
      selectedXslt.XsltId ||
      selectedXslt.XsltID ||
      null

    this.Fatura.FaturaBilgi.FaturaPdfID =
      selectedXslt.FaturaPdfID ||
      selectedXslt.PdfID ||
      selectedXslt.PdfId ||
      selectedXslt.PDFID ||
      0
  }

  this.Fatura.EArsivBilgi.GonderimSekli = this.Bilet.FaturaBilgileri.EfaturaBilgileri.GonderimSekli
  this.Fatura.EArsivBilgi.InternetSatis = this.Bilet.FaturaBilgileri.EfaturaBilgileri.InternetSatis
  this.Fatura.EArsivBilgi.WebAdresi = this.Bilet.FaturaBilgileri.EfaturaBilgileri.WebAdresi
  this.Fatura.EArsivBilgi.OdemeSekli = this.Bilet.FaturaBilgileri.EfaturaBilgileri.OdemeSekli
  this.Fatura.EArsivBilgi.OdemeSekliAciklama = this.Bilet.FaturaBilgileri.EfaturaBilgileri.OdemeSekliAciklama
  this.Fatura.EArsivBilgi.OdemeAraci = this.Bilet.FaturaBilgileri.EfaturaBilgileri.OdemeAraci
  this.Fatura.EArsivBilgi.OdemeTarihi =
    this.Bilet.FaturaBilgileri.EfaturaBilgileri.OdemeTarihi ||
    this.Bilet.TarihBilgileri.SatisTarihi ||
    this.Fatura.FaturaTarih

  this.Fatura.DovizBilgi.DDovizTipi = this.Bilet.TutarBilgileri.Doviz.DovizKod
  this.Fatura.DovizBilgi.DKur = this.Bilet.TutarBilgileri.Kur

  if (!this.Fatura.FaturaTarih) {
    this.text1 = this.$t('Please-enter-invoice-date')
    this.snackbar = true
    return
  }

  if (!this.Fatura.FaturaSeri) {
    this.text1 = this.$t('Please-enter-invoice-serial')
    this.snackbar = true
    return
  }

  if (!this.Fatura.FaturaNo) {
    this.text1 = this.$t('Please-enter-invoice-no')
    this.snackbar = true
    return
  }

  if (!this.Fatura.GibSeri) {
    this.text1 = this.$t('Please-choose-a-gib-series')
    this.snackbar = true
    return
  }

  if (!this.Fatura.BiletBilgi.BiletNo || !this.Fatura.BiletBilgi.CariKod || !this.Fatura.BiletBilgi.CariKod.Kod) {
    this.text1 = this.$t('Ticket-Number-Or-Current-Code-Cannot-Be-Empty')
    this.snackbar = true
    return
  }

  if (!this.Fatura.FaturaBilgi.FaturaID) {
    this.text1 = this.$t('Please-Select-A-Design')
    this.snackbar = true
    return
  }

  this.loadingvmodel = true

  this.$http.post(auth.API_URL + 'api/TicketInvoice/TicketInvoiceAdd', this.Fatura, {
    headers: { Authorization: 'Bearer ' + auth.getAuthHeader() }
  }).then((response) => {
    this.loadingvmodel = false

    if (response.body.FaturaStatus === true) {
      this.faturadialog = false
      this.text1 = response.body.FaturaResponse
      this.snackbar = true

      setTimeout(() => {
        window.open('#/bilet/index', '_self')
      }, 3000)
    } else {
      this.text1 = response.body.FaturaResponse
      this.snackbar = true
    }
  }, (response) => {
    this.loadingvmodel = false
    this.text1 = response.body && response.body.StatusText
      ? response.body.StatusText
      : 'Service Unavailable'
    this.snackbar = true
  })
},
    imageUrlToBase64(url) {
  return new Promise((resolve) => {
    if (!url) {
      resolve('')
      return
    }

    var img = new Image()
    img.crossOrigin = 'Anonymous'

    img.onload = function () {
      var canvas = document.createElement('canvas')
      canvas.width = img.width
      canvas.height = img.height

      var ctx = canvas.getContext('2d')
      ctx.drawImage(img, 0, 0)

      resolve(canvas.toDataURL('image/png'))
    }

    img.onerror = function () {
      resolve('')
    }

    img.src = url
  })
},
   
    simpleUcusListesiYukle() {
  var liste = []

  if (this.Bilet.UcusBilgileri && this.Bilet.UcusBilgileri.UcusListesi) {
    liste = this.Bilet.UcusBilgileri.UcusListesi
  }

  if (!liste || liste.length == 0) {
    this.flightSegments = [
      {
        id: 1,
        UcusTarihi: null,
        UcusSaat: '',
        Havayolu: '',
        UcusNo: '',
        Kalkis: '',
        Varis: '',
        Class: '',
        ClassTipi: '',
        VarisTarihi: null,
        VarisSaati: '',
        FareBases: '',
        Aktarma: false,
        KabinBagaj: '',
        Bagaj: '',
        YemekDurumu: null,
        YemekAciklamasi: '',
        IptalKosullari: '',
        IadeKosullari: ''
      }
    ]

    return
  }

  this.flightSegments = liste.map((item, index) => {

    var ex = (item.ExAciklamalarUcus && item.ExAciklamalarUcus.length)
      ? item.ExAciklamalarUcus[0]
      : {
          KabinBagaj: '',
          Bagaj: '',
          YemekDurumu: null,
          YemekAciklama: '',
          IptalSartlari: '',
          IadeSartlari: ''
        }

    return {
      id: index + 1,

      UcusTarihi: item.UcusTarihi,
      UcusSaat: item.UcusSaat,
      Havayolu: item.UcusHY,
      UcusNo: item.UcusNo,

      Kalkis: item.Parkur,
      Varis: item.Parkur2 || item.Varis || '',

      Class: item.UcusClass,
      ClassTipi: item.UcusClassTip,

      VarisTarihi: item.VarisTarihi,
      VarisSaati: item.VarisSaat,

      FareBases: item.FareBases,
      Aktarma: item.Aktarma,

      KabinBagaj: ex.KabinBagaj,
      Bagaj: ex.Bagaj,
      YemekDurumu: ex.YemekDurumu,
      YemekAciklamasi: ex.YemekAciklama,
      IptalKosullari: ex.IptalSartlari,
      IadeKosullari: ex.IadeSartlari
    }
  })
},
    ticketGetir() {
  var credentials = JSON.parse(window.localStorage.getItem('credentials'));

  var params = {
    SirketKodu: credentials.SirketKodu,
    BiletNo: this.$route.query.biletno,
    HavaYoluKodu: this.$route.query.hyolukod,
    UcusTipi: this.$route.query.ucustipi
  };

  this.loadingvmodel = true;

  this.$http.post(auth.API_URL + 'api/Ticket/TicketGet', params, {
    headers: {
      'Authorization': 'Bearer ' + auth.getAuthHeader()
    }
  }).then((response) => {
    this.loadingvmodel = false;
    this.ticketGetProcess(response.body, 1);
  }, () => {
    this.loadingvmodel = false;
    this.text1 = this.$t('Service-Unavailable') + '/TicketGet';
    this.snackbar = true;
  });
},

voidTicketGetir() {
  var credentials = JSON.parse(window.localStorage.getItem('credentials'));

  var params = {
    SirketKodu: credentials.SirketKodu,
    BiletNo: this.$route.query.biletno,
    HavaYoluKodu: this.$route.query.hyolukod,
    UcusTipi: this.$route.query.ucustipi
  };

  this.loadingvmodel = true;

  this.$http.post(auth.API_URL + 'api/Ticket/VoidGet', params, {
    headers: {
      'Authorization': 'Bearer ' + auth.getAuthHeader()
    }
  }).then((response) => {
    this.loadingvmodel = false;
    this.ticketGetProcess(response.body, 1);
  }, () => {
    this.loadingvmodel = false;
    this.text1 = this.$t('Service-Unavailable') + '/VoidGet';
    this.snackbar = true;
  });
},
    voidyap() {
  this.voiddialog = true
},

biletsilsor() {
  this.kisamesaj = this.$t('Are-you-sure-you-want-to-delete')
  this.btnsilsor = true
  this.dialogkisamesaj = true
},

hykoddegistir() {
  this.vmodelhyKod.HavaYoluKodu = this.Bilet.GenelBilgileri.HavaYoluKodu
  this.vmodelhyKod.UcusTipi = this.Bilet.GenelBilgileri.UcusTipi
  this.vmodelhyKod.AcenteKodu = this.Bilet.GenelBilgileri.AcenteKodu
  this.dialoghydegistir = true
},


    openPdfDialog() {
  this.pdfDialog = true
},

confirmPdfDownload() {
  this.Bilet.PdfLang = this.pdfLang
  this.Bilet.PdfShowAmount = this.pdfShowAmount

  this.pdfDialog = false
  this.downloadPdf()
},

async downloadPdf() {
  let credentials = JSON.parse(window.localStorage.getItem('credentials'))
  this.pdfLoading = true

  try {
    const base64 = await this.imageUrlToBase64(
      this.getImgUrl(this.Bilet.GenelBilgileri.HavaYoluKodu)
    )

    const response = await this.$http.post(
      auth.API_URL + 'api/Ticket/TicketPdfDownload',
      { Bilet: this.Bilet, logo: base64 },
      {
        headers: {
          Authorization: "Bearer " + auth.getAuthHeader(),
          CariSirketNo: credentials.SirketKodu.toString(),
          CoperSirketNo: credentials.CoperSirketNo.toString(),
          MuhasebeSirketNo: credentials.MuhasebeSirketNo.toString()
        },
        responseType: "arraybuffer"
      }
    )

    const blob = new Blob([response.body], { type: 'application/pdf' })
    const link = document.createElement('a')
    link.href = window.URL.createObjectURL(blob)
    link.download = "TicketInvoice.pdf"
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
    window.URL.revokeObjectURL(link.href)
  } catch (error) {
    this.text1 = this.$t('PDF-could-not-be-downloaded')
    this.snackbar = true
  } finally {
    this.pdfLoading = false
  }
},








    tahsilatdagitduzenle() {
  this.netTutarHesapla()
},

odakkaybiServisTahsilat() {
  this.netTutarHesapla()
},

ServisYuzdeAnalizKod() {
  this.netTutarHesapla()
},

serviscodeControl() {},

servisitemsgetir() {
  var credentials = JSON.parse(window.localStorage.getItem('credentials'));

  this.servisclass.Cari.Kod = this.Bilet.GenelBilgileri.MusteriKodu.Kod;
  this.servisclass.SirketKodu = credentials.SirketKodu;
  this.servisclass.Hat = this.Bilet.GenelBilgileri.UcusTipi;
  this.servisclass.DefaultKontrol = false;

  this.$http.post(auth.API_URL + 'api/TicketDefinitons/ServiceCodeList', this.servisclass, {
    headers: {
      'Authorization': 'Bearer ' + auth.getAuthHeader()
    }
  }).then((response) => {
    this.servisitems = response.body;
    this.servisdialog = true;
  }, () => {
    this.text1 = this.$t('Service-Unavailable');
    this.snackbar = true;
  });
},

servisgetir() {
  var credentials = JSON.parse(window.localStorage.getItem('credentials'))

  this.servisclass.Cari.Kod = this.Bilet.GenelBilgileri.MusteriKodu.Kod
  this.servisclass.SirketKodu = credentials.SirketKodu
  this.servisclass.Hat = this.Bilet.GenelBilgileri.UcusTipi
  this.servisclass.DefaultKontrol = true

  var params1 = this.servisclass

  this.$http.post(auth.API_URL + 'api/TicketDefinitons/ServiceCodeList', params1, {
    headers: {
      'Authorization': 'Bearer ' + auth.getAuthHeader()
    }
  }).then((response) => {
    if (response.body.length != 0) {
      this.Bilet.TanimBilgileri.ServisKod = response.body[0].Kod

      var params = {
        HavayoluKodu: this.Bilet.GenelBilgileri.HavaYoluKodu,
        SirketKodu: credentials.SirketKodu,
        ServisKodBilgi: response.body[0],
        KurTarih: this.Bilet.TarihBilgileri.SatisTarihi,
        TutarBilgi: {
          ServisTutar: this.Bilet.TutarBilgileri.ServisTutar.ServisTutar,
          BiletTutar: this.Bilet.TutarBilgileri.Tutar.Tutar,
          VergiTutar:
            Number(this.Bilet.TutarBilgileri.PtaTutar.PtaTutar || 0) +
            (this.isDomesticTicket
              ? Number(this.Bilet.TutarBilgileri.AlanVergiTutar.AlanVergiTutar || 0) +
                Number(this.Bilet.TutarBilgileri.YFFTutar.YFFTutar || 0)
              : Number(this.Bilet.TutarBilgileri.TaxTutar.TaxTutar || 0))
        }
      }

      this.$http.post(auth.API_URL + 'api/Helpers/GetServiceCodePrice', params, {
        headers: auth.getAuthCompaniesInfo()
      }).then((response) => {
        this.Bilet.TutarBilgileri.IskontoTutar.IskontoTutar = response.body.IskontoTutar

        if (!this.servisTutarManuel && response.body.ServisTutar > 0.0) {
          this.Bilet.TutarBilgileri.ServisTutar.ServisTutar = response.body.ServisTutar
        }

        this.netTutarHesapla()
      }, () => {
        this.text1 = this.$t('Service-Unavailable') + '-GetServiceCodePrice'
        this.snackbar = true
      })
    }
  }, () => {
    this.text1 = this.$t('Service-Unavailable')
    this.snackbar = true
  })
},

servissec(item) {
  if (!item) return

  this.Bilet.TanimBilgileri.ServisKod = item.Kod
  this.Bilet.TutarBilgileri.ServisTutar.ServisTutar = Number(item.Tutar || 0)
  this.servisdialog = false
  this.netTutarHesapla()
},

netTutarHesapla() {
  const tutar = Number(this.Bilet.TutarBilgileri.Tutar.Tutar || 0)
  const vergi = this.isDomesticTicket
    ? Number(this.Bilet.TutarBilgileri.YFFTutar.YFFTutar || 0) +
      Number(this.Bilet.TutarBilgileri.AlanVergiTutar.AlanVergiTutar || 0)
    : Number(this.Bilet.TutarBilgileri.TaxTutar.TaxTutar || 0)
  const ceza = Number(this.Bilet.TutarBilgileri.CezaTutar.CezaTutar || 0)
  const pta = Number(this.Bilet.TutarBilgileri.PtaTutar.PtaTutar || 0)
  const servis = Number(this.Bilet.TutarBilgileri.ServisTutar.ServisTutar || 0)
  const dff = Number(this.Bilet.TutarBilgileri.ReserveTutar.ReserveTutar || 0)
  const iskonto = Number(this.Bilet.TutarBilgileri.IskontoTutar.IskontoTutar || 0)

  this.Bilet.TutarBilgileri.NetTutar.NetTutar =
    tutar + vergi + ceza + pta + servis + dff - iskonto
},
    sayfakapat() {
  window.open('#/bilet/index', '_self')
},
    popupDevamEt() {

  if (!this.Bilet.GenelBilgileri.BiletNo) {
    this.text1 = this.$t('Please-Enter-Ticket-Number');
    this.snackbar = true;
    return;
  }

  this.yeniKayitDialog = false;
},
    checkCounter() {
  this.counter = 0
  this.counter += 1

  if (this.counter == 1) {
    this.biletkaydet()
  }
},
biletkaydet() {
  this.loadingvmodel = true

  if (this.isDomesticTicket) {
    this.Bilet.TutarBilgileri.TaxTutar.TaxTutar = 0
  } else {
    this.Bilet.TutarBilgileri.YFFTutar.YFFTutar = 0
    this.Bilet.TutarBilgileri.AlanVergiTutar.AlanVergiTutar = 0
  }

  this.netTutarHesapla()

  if (!this.Bilet.GenelBilgileri.MusteriKodu || !this.Bilet.GenelBilgileri.MusteriKodu.Kod) {
    this.text1 = this.$t('Please-Select-Current-Account')
    this.snackbar = true
    this.counter = 0
    this.loadingvmodel = false
    return
  }

  if (!this.Bilet.GenelBilgileri.BiletNo) {
    this.text1 = this.$t('Please-Enter-Ticket-Number')
    this.snackbar = true
    this.counter = 0
    this.loadingvmodel = false
    return
  }

  var credentials = JSON.parse(window.localStorage.getItem('credentials'))

  this.Bilet.GenelBilgileri.Status = 'S'
  this.Bilet.GenelBilgileri.SirketKodu = credentials.SirketKodu

  if (this.faturalansinmi == false) {
    this.Bilet.FaturaBilgileri.FaturaSeri = 'H'
  } else {
    this.Bilet.FaturaBilgileri.FaturaSeri = null
  }

  this.Bilet.UcusBilgileri = {
    UcusListesi: this.simpleUcusListesiHazirla(credentials)
  }

  this.Bilet.TarihBilgileri.OdemeTarihi =
  this.Bilet.TarihBilgileri.SatisTarihi

  this.Bilet.OdemeBilgileri.OdemeTarihi =
  this.Bilet.TarihBilgileri.SatisTarihi

  this.Bilet.NotlarBilgileri.DateofRes =
  this.Bilet.NotlarBilgileri.DateofRes || this.Bilet.TarihBilgileri.SatisTarihi

  var paramsbilet = this.Bilet


  this.$http.post(auth.API_URL + 'api/Ticket/TicketAddAndLoad', paramsbilet, {
    headers: {
      'Authorization': 'Bearer ' + auth.getAuthHeader()
    }
  }).then((response) => {
    this.text1 = this.$t(response.body.ResponseMessage)
    this.snackbar = true
    this.loadingvmodel = false

    if (response.body.Status != Boolean(false)) {
      this.ticketGetProcess(response.body.Bilet, 2)
    } else {
      this.counter = 0
    }
  }, (response) => {
    this.text1 = this.$t('Service-Unavailable')
    this.snackbar = true
    this.counter = 0
    this.loadingvmodel = false
  })
},

ticketGetProcess(ticketResponse, process) {
  if (!ticketResponse) {
    this.loadingvmodel = false;
    this.counter = 0;
    this.text1 = this.$t('Ticket-Information-Could-Not-Be-Read');
    this.snackbar = true;
    return;
  }

  this.Bilet = ticketResponse;
  this.normalizeTicketForRender();

  this.guncellebtngorunum = true;

  this.voidbtn = this.Bilet.GenelBilgileri.Status == "S";
  this.iadebtn = this.Bilet.GenelBilgileri.Status == "S";
  this.faturabtn = Number(this.Bilet.FaturaBilgileri.FaturaNo) > 0;
  this.faturanovarise = Number(this.Bilet.FaturaBilgileri.FaturaNo) > 0;

  this.simpleUcusListesiYukle();

  if (process == 2) {
    var url = "#/bilet/newbilet2?isl=get&hyolukod=" +
      this.Bilet.GenelBilgileri.HavaYoluKodu +
      "&biletno=" + this.Bilet.GenelBilgileri.BiletNo +
      "&ucustipi=" + this.Bilet.GenelBilgileri.UcusTipi;

    window.history.replaceState(null, "", url);
  }
},

simpleUcusListesiHazirla(credentials) {
  var liste = []
  var parkurno = 1

  this.flightSegments.forEach((segment) => {
    if (
      segment.UcusTarihi ||
      segment.UcusSaat ||
      segment.Havayolu ||
      segment.UcusNo ||
      segment.Kalkis ||
      segment.Varis ||
      segment.Class ||
      segment.ClassTipi ||
      segment.KabinBagaj ||
      segment.Bagaj ||
      segment.YemekDurumu ||
      segment.YemekAciklamasi ||
      segment.IptalKosullari ||
      segment.IadeKosullari
    ) {
      liste.push({
        Aktarma: segment.Aktarma,
        BiletNo: this.Bilet.GenelBilgileri.BiletNo,
        FareBases: segment.FareBases,
        Formno: this.Bilet.GenelBilgileri.Formno,
        ID: 0,
        Parkur: segment.Kalkis,
        ParkurNo: parkurno,
        SirketKodu: credentials.SirketKodu,
        UcusClass: segment.Class,
        UcusClassTip: segment.ClassTipi,
        UcusHY: segment.Havayolu,
        UcusNo: segment.UcusNo,
        UcusSaat: segment.UcusSaat,
        UcusTarihi: segment.UcusTarihi,
        VarisSaat: segment.VarisSaati,
        VarisTarihi: segment.VarisTarihi,

        ExAciklamalarUcus: [
          {
            UcusIndex: parkurno,
            KabinBagaj: segment.KabinBagaj || '',
            Bagaj: segment.Bagaj || '',
            YemekDurumu: segment.YemekDurumu,
            YemekAciklama: segment.YemekAciklamasi || '',
            IptalSartlari: segment.IptalKosullari || '',
            IadeSartlari: segment.IadeKosullari || ''
          }
        ]
      })

      parkurno++
    }
  })

  return liste
},

    getCurrentInfov2(currentInfo) {
  if (!currentInfo) return;

  var customerCode =
    currentInfo.Kod ||
    currentInfo.Code ||
    currentInfo.kod ||
    currentInfo.code ||
    "";

  customerCode = customerCode ? customerCode.toString().trim() : "";

  if (!customerCode) return;

  // Cari component v-model'i eventten önce güncelleyebildiği için aynı cari
  // kontrolünde metottan çıkma. Fatura bilgileri yine doldurulmalı.
  var sameCurrent = Boolean(
    this.Bilet &&
    this.Bilet.GenelBilgileri &&
    this.Bilet.GenelBilgileri.MusteriKodu &&
    this.Bilet.GenelBilgileri.MusteriKodu.Kod === customerCode
  );

  // Objeyi komple event ile değiştirme. Sadece gerekli alanları yaz.
  if (!this.Bilet.GenelBilgileri.MusteriKodu) {
    this.Bilet.GenelBilgileri.MusteriKodu = {};
  }

  this.Bilet.GenelBilgileri.MusteriKodu.Kod = customerCode;
  this.Bilet.GenelBilgileri.MusteriKodu.Unvan =
    currentInfo.Title ||
    currentInfo.Unvan ||
    currentInfo.Isim ||
    "";

  this.Bilet.GenelBilgileri.MusteriKodu.Uyari =
    currentInfo.WarningNote || "";

  this.profileforced = currentInfo.ProfileForced;
  this.eFaturaBilgi = Number(currentInfo.EInvoiceCustomer || 0);
  this.earsivseridurum = this.eFaturaBilgi === 1 ? 1 : 0;

  if (this.Fatura && this.Fatura.EFaturaBilgi) {
    this.Fatura.EFaturaBilgi.Unvani = currentInfo.Title || "";
    this.Fatura.EFaturaBilgi.Unvani2 = currentInfo.Title2 || "";

    if (currentInfo.Invoice) {
      this.Fatura.EFaturaBilgi.Adres1 = currentInfo.Invoice.Address || "";
      this.Fatura.EFaturaBilgi.IlceSehir = currentInfo.Invoice.Province || "";
      this.Fatura.EFaturaBilgi.VergiDairesi = currentInfo.Invoice.TaxOffice || "";
      this.Fatura.EFaturaBilgi.VergiNo = currentInfo.Invoice.TaxNumber || "";
      this.Fatura.EFaturaBilgi.TcKimlikNo = currentInfo.Invoice.IdentityNumber || "";
      this.Fatura.EFaturaBilgi.Adi = currentInfo.Invoice.PerFirstName || "";
      this.Fatura.EFaturaBilgi.Soyadi = currentInfo.Invoice.PerFamilyName || "";
      this.Fatura.EFaturaBilgi.TUnvani = currentInfo.Invoice.PerTitle || "";
      this.Fatura.EFaturaBilgi.DigerAdi = currentInfo.Invoice.PerMiddleName || "";
      this.Fatura.EFaturaBilgi.OnAdiEki = currentInfo.Invoice.PerNameSuffix || "";
    }

    this.Fatura.EFaturaBilgi.Email = currentInfo.Email || "";
  }

  this.warningNote = currentInfo.WarningNote || "";

  try {
    this.warningNote = this.warningNote.replace(/[\n\r\t]/gm, "");
  } catch (e) {}

  if (!sameCurrent && this.warningNote) {
    this.warningNotedialog = true;
  }

  // Masraf merkezi boşsa normal sayfadaki mantığa benzer şekilde doldur.
  if (
    this.Bilet.GenelBilgileri.Masraf &&
    (
      this.Bilet.GenelBilgileri.Masraf.Code === null ||
      this.Bilet.GenelBilgileri.Masraf.Code === undefined ||
      this.Bilet.GenelBilgileri.Masraf.Code === ""
    )
  ) {
    if (
      currentInfo.ExpenseCenter &&
      (
        currentInfo.ExpenseCenter.Code ||
        currentInfo.ExpenseCenter.Kod
      )
    ) {
      this.Bilet.GenelBilgileri.Masraf.Code =
        currentInfo.ExpenseCenter.Code ||
        currentInfo.ExpenseCenter.Kod ||
        "";
    }
  }
},

    addFlightSegment() {
      if (this.flightSegments.length >= 5) return

      this.flightSegments.push({
        id: Date.now() + this.flightSegments.length,
        UcusTarihi: null,
        UcusSaat: '',
        Havayolu: '',
        UcusNo: '',
        Kalkis: '',
        Varis: '',
        Class: '',
        ClassTipi: '',
        VarisTarihi: null,
        VarisSaati: '',
        FareBases: '',
        Aktarma: false,
        KabinBagaj: '',
        Bagaj: '',
        YemekDurumu: null,
        YemekAciklamasi: '',
        IptalKosullari: '',
        IadeKosullari: ''
      })
    },

    removeFlightSegment(index) {
      if (this.flightSegments.length === 1) return
      this.flightSegments.splice(index, 1)
    },

    getImgUrl(code) {
  if (!code) return '';

  try {
    return require(`@/assets/airlinelogo/${code.toUpperCase()}.png`);
  } catch (e) {
    return '';
  }
},

yeniiadeekle() {
  var url = '#/bilet/simplebiletiade/id?' +
    'isl=yeniiade' +
    '&hyolukod=' + this.Bilet.GenelBilgileri.HavaYoluKodu +
    '&biletno=' + this.Bilet.GenelBilgileri.BiletNo +
    '&formno=' + this.Bilet.GenelBilgileri.Formno +
    '&sirano=' + this.Bilet.GenelBilgileri.Sirano +
    '&ucustipi=' + this.Bilet.GenelBilgileri.UcusTipi

  window.open(url, '_self')
},

voidyap() {
  this.voiddialog = true
},

biletsilsor() {
  if (this.faturanovarise == true) {
    this.text1 = this.$t('You-cannot-delete-an-invoiced-ticket')
    this.snackbar = true
    return
  }

  this.kisamesaj = this.$t('Are-you-sure-you-want-to-delete')
  this.btnsilsor = true
  this.dialogkisamesaj = true
},

hykoddegistir() {
  if (this.faturanovarise == true) {
    this.text1 = this.$t('You-cannot-change-the-airline-code-of-the-invoiced-ticket')
    this.snackbar = true
    return
  }

  this.vmodelhyKod.HavaYoluKodu = this.Bilet.GenelBilgileri.HavaYoluKodu
  this.vmodelhyKod.UcusTipi = this.Bilet.GenelBilgileri.UcusTipi
  this.vmodelhyKod.AcenteKodu = this.Bilet.GenelBilgileri.AcenteKodu
  this.dialoghydegistir = true
},





getDateNow() {
  var date = new Date()
  var gun = date.getDate()
  var ay = date.getMonth() + 1
  var yil = date.getFullYear()

  if (ay < 10) ay = '0' + ay
  if (gun < 10) gun = '0' + gun

  return yil + '-' + ay + '-' + gun
},

normalBiletSayfasinaGit() {
  var isl = this.Bilet.GenelBilgileri.Status == 'V' ? 'voidget' : 'get'

  var url = '#/bilet/yeni/id?' +
    'isl=' + isl +
    '&hyolukod=' + this.Bilet.GenelBilgileri.HavaYoluKodu +
    '&biletno=' + this.Bilet.GenelBilgileri.BiletNo +
    '&ucustipi=' + this.Bilet.GenelBilgileri.UcusTipi

  window.open(url, '_self')
},

biletsil() {
  var credentials = JSON.parse(window.localStorage.getItem('credentials'))
  var manage = JSON.parse(window.localStorage.getItem('WebUserManageLoad'))

  var paramsvoid = {
    SirketKodu: credentials.SirketKodu,
    BiletNo: this.Bilet.GenelBilgileri.BiletNo,
    HavayoluKodu: this.Bilet.GenelBilgileri.HavaYoluKodu,
    Formno: this.Bilet.GenelBilgileri.Formno,
    UcusTipi: this.Bilet.GenelBilgileri.UcusTipi,
    Login: {
      UserID: manage.UserInfo.UserID,
      Email: manage.UserInfo.Email
    },
    IssueDate: this.getDateNow()
  }

  this.$http.post(auth.API_URL + 'api/Ticket/TicketDelete', paramsvoid, {
    headers: {
      'Authorization': 'Bearer ' + auth.getAuthHeader()
    }
  }).then((response) => {
    this.text1 = this.$t(response.body.ResponseMessage)
    this.snackbar = true

    if (response.body.Status == true) {
      this.dialogkisamesaj = false

      setTimeout(function () {
        this.sayfakapat()
      }.bind(this), 750)
    }
  }, () => {
    this.text1 = this.$t('Service-Unavailable')
    this.snackbar = true
  })
},

havayoluKoddegistir() {
  if (this.vmodelhyKod.HavaYoluKodu == null || this.vmodelhyKod.UcusTipi == null) {
    this.text1 = this.$t('Please-Select-Airline-Code-And-Flight-Type')
    this.snackbar = true
    return
  }

  var credentials = JSON.parse(window.localStorage.getItem('credentials'))

  var acentebileti = this.vmodelhyKod.AcenteKodu != null

  var params = {
    BiletBilgi: {
      SirketKodu: credentials.SirketKodu,
      HavayoluKodu: this.Bilet.GenelBilgileri.HavaYoluKodu,
      FormNo: this.Bilet.GenelBilgileri.Formno,
      BiletNo: this.Bilet.GenelBilgileri.BiletNo,
      SatisTarihi: this.Bilet.TarihBilgileri.SatisTarihi
    },
    HavaYoluKodu: this.vmodelhyKod.HavaYoluKodu,
    UcusTipi: this.vmodelhyKod.UcusTipi,
    AcenteBilet: acentebileti,
    AcenteKodu: this.vmodelhyKod.AcenteKodu,
    UserID: credentials.UserID
  }

  this.$http.post(auth.API_URL + 'api/Ticket/TicketAirlineChange', params, {
    headers: {
      'Authorization': 'Bearer ' + auth.getAuthHeader()
    }
  }).then((response) => {
    this.text1 = this.$t(response.body.ResponseMessage)
    this.snackbar = true

    if (response.body.Status == true) {
      this.dialoghydegistir = false

      setTimeout(function () {
        var url = '#/bilet/newbilet2/id?' +
          'isl=get' +
          '&hyolukod=' + this.vmodelhyKod.HavaYoluKodu +
          '&biletno=' + this.Bilet.GenelBilgileri.BiletNo +
          '&ucustipi=' + this.vmodelhyKod.UcusTipi

        window.open(url, '_self')
      }.bind(this), 750)
    }
  }, () => {
    this.text1 = this.$t('Service-Unavailable')
    this.snackbar = true
  })
},



    getparabirimi() {
      return helpers.getparabirimi()
    }
  },

  
}
</script>

<style scoped>

.hero-actions {
  display: flex;
  align-items: center;
  gap: 8px;
}

.hero-more-btn {
  background: #fff !important;
  color: #10255c !important;
  border-radius: 18px !important;
}
.invoice-status-pill {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  margin-top: 10px;
  padding: 6px 12px;
  border-radius: 999px;
  background: #22c55e;
  color: white;
  font-size: 13px;
  font-weight: 700;
}

.invoice-status-pill.passive {
  background: #ef4444;
}

.invoice-switch-wrap {
  display: flex;
  align-items: center;
  justify-content: center; /* ORTALAMA */
  gap: 10px;
  margin-top: 10px;
}

.switch-label {
  font-size: 14px;
  color: #64748b;
  font-weight: 600;
}
.ticket-page {
  min-height: 100vh;
  padding: 20px;
  background:
    radial-gradient(circle at top left, rgba(37, 99, 235, 0.08), transparent 28%),
    radial-gradient(circle at top right, rgba(14, 165, 233, 0.08), transparent 24%),
    linear-gradient(180deg, #f8fafc 0%, #eef3f9 100%);
}

.hero-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 18px;
  padding: 24px 28px;
  margin-bottom: 0;
  border-radius: 24px 24px 0 0;
  background: linear-gradient(135deg, #0f172a 0%, #1d4ed8 55%, #0ea5e9 100%);
  box-shadow: 0 18px 42px rgba(15, 23, 42, 0.18);
}

.hero-badge {
  display: inline-block;
  padding: 6px 12px;
  margin-bottom: 10px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 700;
  color: #dbeafe;
  background: rgba(255,255,255,0.14);
}

.hero-title {
  margin: 0;
  color: #fff;
  font-size: 30px;
  font-weight: 800;
}

.hero-subtitle {
  margin-top: 6px;
  color: rgba(255,255,255,0.78);
  font-size: 14px;
}

.hero-btn {
  border-radius: 14px !important;
  text-transform: none !important;
  font-weight: 700;
  background: #fff !important;
  color: #0f172a !important;
}

.general-wrapper-card,
.content-card {
  border-radius: 22px !important;
  background: rgba(255,255,255,0.92) !important;
  border: 1px solid rgba(148, 163, 184, 0.16);
  box-shadow: 0 12px 35px rgba(15, 23, 42, 0.08);
  overflow: hidden;
}

.general-wrapper-card {
  padding: 0 0 18px 0;
}

.summary-card {
  padding: 18px 20px;
  background: rgba(255,255,255,0.96);
  border: 1px solid rgba(148, 163, 184, 0.16);
  box-shadow: 0 12px 35px rgba(15, 23, 42, 0.08);
}



.general-inner {
  padding: 8px 12px 0;
}

.summary-grid {
  display: grid;
  grid-template-columns: 1.6fr .7fr;
  gap: 24px;
  align-items: center;
}

.summary-airline {
  display: flex;
  gap: 18px;
  align-items: center;
}

.airline-logo-wrap {
  width: 72px;
  min-width: 72px;
  height: 72px;
  border-radius: 18px;
  background: #fff;
  box-shadow: inset 0 0 0 1px rgba(148, 163, 184, 0.18);
  display: flex;
  align-items: center;
  justify-content: center;
}

.airline-line {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 10px;
  margin-bottom: 8px;
}

.ticket-code {
  font-size: 24px;
  font-weight: 800;
  color: #334155;
}

.meta-line {
  color: #64748b;
  font-size: 14px;
  line-height: 1.7;
}

.summary-total {
  text-align: right;
  padding-right: 8px;
}

.summary-amount {
  font-size: 36px;
  font-weight: 800;
  color: #ef4444;
}

.summary-amount-sub {
  font-size: 15px;
  font-weight: 700;
  color: #f97316;
  margin-top: 4px;
}

.summary-label {
  margin-top: 10px;
  color: #64748b;
  font-size: 16px;
}

.page-section {
  margin-bottom: 24px;
}

.section-header {
  margin-bottom: 12px;
  padding-left: 4px;
}

.section-header--with-action {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
}

.section-header h2 {
  margin: 0;
  font-size: 22px;
  font-weight: 800;
  color: #0f172a;
}

.section-header p {
  margin: 4px 0 0;
  color: #64748b;
  font-size: 14px;
}

.card-title {
  padding: 20px 22px 10px;
  font-size: 18px;
  font-weight: 800;
  color: #0f172a;
}

.modern-field {
  margin-bottom: 10px;
}

.modern-switch,
.modern-check {
  margin-top: 0 !important;
}

.add-flight-btn {
  border-radius: 14px !important;
  text-transform: none !important;
  font-weight: 700;
}

.flight-block {
  margin-bottom: 16px;
}

.flight-card {
  padding: 0;
}

.flight-grid {
  display: grid;
  grid-template-columns: 260px 1fr 56px;
  gap: 0;
  align-items: stretch;
}

.flight-visual {
  min-height: 210px;
  background:
    linear-gradient(rgba(15, 23, 42, 0.28), rgba(15, 23, 42, 0.28)),
    url("https://cdn.vuetifyjs.com/images/cards/plane.jpg");
  background-size: cover;
  background-position: center;
  position: relative;
}

.flight-overlay {
  position: absolute;
  left: 22px;
  top: 22px;
  font-size: 28px;
  font-weight: 900;
  color: white;
  text-shadow: 0 3px 18px rgba(0,0,0,0.45);
}

.flight-fields {
  padding: 18px 18px 8px;
}

.flight-actions {
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding-top: 10px;
}

.flight-transfer {
  display: flex;
  align-items: center;
}

.special-card {
  margin-bottom: 16px;
}

.special-title {
  padding: 16px 20px;
  background: linear-gradient(90deg, #64748b 0%, #94a3b8 100%);
  color: white;
  font-size: 18px;
  font-weight: 800;
}

.profile-actions {
  display: flex;
  align-items: center;
  gap: 8px;
  min-height: 56px;
}


.summary-card--top {
  margin: 0 0 18px 0;
  border-radius: 0 0 24px 24px;
  border-top: none;
}


@media (max-width: 1200px) {
  .flight-grid {
    grid-template-columns: 1fr;
  }

  .flight-visual {
    min-height: 180px;
  }

  .flight-actions {
    justify-content: flex-end;
    padding: 0 16px 12px;
  }
}

@media (max-width: 960px) {
  .hero-bar {
    flex-direction: column;
    align-items: flex-start;
  }

  .summary-grid {
    grid-template-columns: 1fr;
  }

  .summary-total {
    text-align: left;
    padding-right: 0;
  }

  .ticket-code {
    font-size: 18px;
  }

  .summary-amount {
    font-size: 28px;
  }

  .section-header--with-action {
    flex-direction: column;
    align-items: flex-start;
  }
}
.agency-ticket-chip {
  display: flex !important;
  width: fit-content;
  height: auto !important;
  min-height: 34px;
  margin: 8px 0 10px !important;
  padding: 6px 12px !important;
  border-radius: 10px !important;
  background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%) !important;
  box-shadow: 0 4px 12px rgba(220, 38, 38, 0.25);
  font-size: 13px;
  font-weight: 600;
}

.agency-ticket-code {
  margin: 0 4px;
  font-weight: 900;
  text-transform: uppercase;
}
</style>
